(function(){
  var root=document.currentScript.closest('.rc-club-mount')||document;
  var club=document.querySelector('.rc-club'); if(!club) return;
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  club.classList.add('js');
  // Declared HERE, before anything reads it. It previously sat further down the script: `var`
  // hoisting made it `undefined` for the guest calculator below, which threw and — because the
  // throw was uncaught — halted the REST of the script including the LoyaltyLion rendering.
  // Seeded by the section (Liquid can't run inside an asset). Falls back to the live config
  // if the metafield is ever empty, so the tier maths never runs on nothing.
  var TIERS=(window.RC_TIERS && window.RC_TIERS.length) ? window.RC_TIERS
    : [{"id":28162,"name":"Foodie","min":0,"max":250,"rate":5},
       {"id":28163,"name":"Indulgent","min":250,"max":1000,"rate":7},
       {"id":28164,"name":"Connoisseur","min":1000,"max":null,"rate":10}];
  revealSetup();   // runs for guests AND members — never gate content on the member path

  // --- Guest: "Where would you land?" tier calculator -------------------------------
  // Answers the hero's claim with the visitor's own number. No LoyaltyLion data needed,
  // so it works before they have an account. Input-driven only: nothing runs until touched.
  // try/catch on purpose: these are optional enhancements. An uncaught throw here would halt
  // the rest of the script and take the LoyaltyLion member rendering down with it — which is
  // exactly what happened when TIERS was read before it was declared.
  try{
  (function(){
    var rng=club.querySelector('[data-calc="range"]'); if(!rng) return;
    var set=function(k,v){ var e=club.querySelector('[data-calc="'+k+'"]'); if(e) e.innerHTML=v; };
    function update(){
      var spend=+rng.value;
      var ti = spend>=1000 ? 2 : (spend>=250 ? 1 : 0);
      var t=TIERS[ti], perSlice=Math.round(1000/t.rate);
      set('spend','RM'+spend.toLocaleString());
      set('tier',t.name);
      // Sells the forward EARN RATE, not lifetime-spend × rate. The old version multiplied their
      // years of spend by the rate ("that's 21,000 Crumbs, 21 free slices") — implying a signup
      // windfall that does NOT exist: past orders set the TIER, not the Crumbs balance. Same
      // retroactive-Crumbs over-promise we fixed in the member FAQ; kept consistent here.
      set('detail', spend===0
        ? 'Start at <b>Foodie</b> and climb as you order — everything counts from day one.'
        : (ti===2?'Our top tier. ':'')+'You&rsquo;d earn <b>'+t.rate+' Crumbs per RM1</b> going forward — '
          +'a free cake slice about every <b>RM'+perSlice.toLocaleString()+'</b> you spend.');
    }
    rng.addEventListener('input',update);
    update();
  })();

  // --- Guest sticky CTA: appear once the hero is out of view --------------------------
  // Observer rather than a scroll listener — fires twice, costs nothing while idle.
  (function(){
    var bar=club.querySelector('[data-guest-cta]'); if(!bar) return;
    var hero=club.querySelector('.s-ghero');
    if(!hero || !('IntersectionObserver' in window)){ bar.classList.add('is-on'); return; }
    new IntersectionObserver(function(es){
      es.forEach(function(e){ bar.classList.toggle('is-on', !e.isIntersecting); });
    },{threshold:0}).observe(hero);
  })();

  // The guest-range formatter that lived here is gone with the rest of the Crumb figures
  // (12 Aug 2026) — it read data-c0/data-c2, which the card no longer renders.

  }catch(e){ /* enhancement failed; core page and member rendering continue */ }

  // --- Pick your goal ----------------------------------------------------------------
  // Writes the reward id to localStorage and re-runs render(), so the card state, the nudge, its
  // progress bar and the sticky bar all update from one source instead of being patched by hand
  // in four places. Tapping the current goal clears it.
  // Klaviyo goal sync: makes the starred goal ACCOUNT-LEVEL so lifecycle flows can nudge toward it
  // (email natively + WhatsApp via Respond.io). We POST straight to Klaviyo's public client-events
  // endpoint rather than the klaviyo.js wrapper — verified 28 Jul that wrapper events don't deliver
  // on this store, but the direct /client/events/ call returns 202 and lands in ~20s. company_id is
  // the PUBLIC site id (safe in browser JS; no private key). One call records the metric (flow
  // trigger) AND updates the profile's goal properties (segmentation). Metrics: "Loyalty Goal
  // Set/Cleared/Ready/Achieved". Fully guarded + keepalive so it survives a re-render/navigation.
  var KL_COMPANY='UWy95Y';
  var _claimedIds=null;   // session snapshot of redeemed reward ids, for goal-achieved detection
  function klGoal(metric, cd, extra){
    try{
      var c=(window.loyaltylion&&window.loyaltylion.customer)||null;
      if(!c||!c.email) return;
      var rid=cd?cd.dataset.rid:null, cost=cd?(+cd.dataset.cost):null,
          label=cd?((cd.dataset.name||(cd.querySelector('.card__title,.vcard__amt')||{}).textContent||'').trim()):null,
          bal=c.pointsApproved||0;
      var props={reward:label,reward_id:rid,cost_crumbs:cost,crumbs_balance:bal,
        crumbs_to_go:(cost!=null?Math.max(0,cost-bal):null)};
      for(var k in (extra||{})) props[k]=extra[k];
      var profileProps={sweet_club_goal_active:!!cd, sweet_club_goal_reward:(cd?label:null),
        sweet_club_goal_reward_id:(cd?rid:null), sweet_club_goal_cost:(cd?cost:null)};
      // Profile properties (segmentation): the event call identifies the profile but doesn't patch
      // custom props, so set them via the client-profiles endpoint too.
      fetch('https://a.klaviyo.com/client/profiles/?company_id='+KL_COMPANY,{
        method:'POST', keepalive:true,
        headers:{'Content-Type':'application/json','revision':'2024-10-15'},
        body:JSON.stringify({data:{type:'profile',attributes:{email:c.email, properties:profileProps}}})
      }).catch(function(){});
      fetch('https://a.klaviyo.com/client/events/?company_id='+KL_COMPANY,{
        method:'POST', keepalive:true,
        headers:{'Content-Type':'application/json','revision':'2024-10-15'},
        body:JSON.stringify({data:{type:'event',attributes:{
          properties:props,
          metric:{data:{type:'metric',attributes:{name:metric}}},
          profile:{data:{type:'profile',attributes:{email:c.email, properties:profileProps}}}
        }}})
      }).catch(function(){});
    }catch(e){}
  }
  (function(){
    var sec=club.querySelector('.s-treats'); if(!sec) return;
    sec.addEventListener('click',function(ev){
      var btn=ev.target.closest('[data-goal]'); if(!btn) return;
      ev.preventDefault(); ev.stopPropagation();          // never trigger redeem or the ringgit flip
      var cd=btn.closest('[data-rid]'); if(!cd) return;
      try{
        var cur=localStorage.getItem('rc_goal_v1');
        if(cur===cd.dataset.rid){ localStorage.removeItem('rc_goal_v1'); localStorage.removeItem('rc_goal_ready'); klGoal('Loyalty Goal Cleared', null); }
        else { localStorage.setItem('rc_goal_v1', cd.dataset.rid); localStorage.removeItem('rc_goal_ready'); klGoal('Loyalty Goal Set', cd); }
      }catch(e){ return; }                                 // private mode: leave the page untouched
      if(window.__rcRender) window.__rcRender();
    });
  })();

  // --- Locked reward -> a plan, in ringgit -------------------------------------------
  // "100 Crumbs to go" is a number; "About RM20 more" is something you can act on. Delegated, so
  // it survives the grid being reordered and the See-all toggle, and bound once at init rather
  // than per card. Values are computed in render() at the member's own earn rate; this only swaps
  // text, so a tap can never produce a wrong figure.
  (function(){
    var sec=club.querySelector('.s-treats'); if(!sec) return;
    function flip(el){
      if(!el.dataset.plan) return;
      var showing=el.classList.toggle('rc__go--plan');
      el.textContent = showing ? el.dataset.plan : el.dataset.crumbs;
    }
    sec.addEventListener('click',function(ev){
      var el=ev.target.closest('.rc__go--tap'); if(!el) return;
      ev.preventDefault(); ev.stopPropagation(); flip(el);
    });
    sec.addEventListener('keydown',function(ev){
      if(ev.key!=='Enter' && ev.key!==' ') return;
      var el=ev.target.closest && ev.target.closest('.rc__go--tap'); if(!el) return;
      ev.preventDefault(); flip(el);
    });
  })();

  // --- Reveal the rest of the flavours on demand (guest AND member) -------------------
  // Deliberately OUTSIDE the try above. It used to sit inside, which meant one throw in a guest
  // enhancement — as happened once with a hoisting bug — would silently take the toggle with it,
  // and a member would be stuck at six flavours with a dead button.
  (function(){
    var btn=club.querySelector('[data-more]'); if(!btn) return;
    btn.addEventListener('click',function(){
      var grid=club.querySelector('.cards'); if(!grid) return;
      var open=grid.classList.toggle('show-all');
      btn.innerHTML = open ? 'See less &uarr;' : 'See all '+(btn.dataset.count||'')+' flavours &rarr;';
      if(!open) grid.scrollIntoView({block:'start',behavior:reduce?'auto':'smooth'});
    });
  })();
  // Mirrors the "Referral share message" configured on the LoyaltyLion referral rule —
  // keep the two in sync so the wording is identical wherever a member shares from.
  var SHARE_MSG="I'm obsessed with Elevete's cakes 🍰 Here's a free cake slice for your first order. Add any slice from a cake's Cake Slices tab and use the code at checkout:";
  var UNLOCK={1:'Exclusive flavour previews',2:'First dibs on limited editions'};

  function toGuest(){ club.classList.remove('is-member'); club.classList.add('is-guest'); }
  function q(s){ return club.querySelector(s); } function qa(s){ return club.querySelectorAll(s); }

  function render(c){
    club.classList.remove('is-guest'); club.classList.add('is-member');
    // Re-entry point for the goal picker: re-render from the SAME customer object so one tap
    // updates card state, nudge, progress bar and sticky bar together, with no page reload and
    // no second source of truth. Guarded so a re-render can never run before the first one.
    // Caught so one bad re-render can't kill the click handler, but NOT swallowed: a throw part
    // way through leaves the card half-updated (new title, stale eyebrow), which is invisible
    // without this line and very hard to diagnose from a screenshot.
    window.__rcRender=function(){ try{ render(c); }catch(e){ if(window.console) console.warn('[sweet-club] re-render failed:',e); } };
    var pts = (c.pointsRedeemable!=null?c.pointsRedeemable:(c.pointsApproved||0));
    qa('[data-ll="firstName"]').forEach(function(e){e.textContent=c.firstName||'there';});
    // Local hour, so a member ordering cake at 11pm isn't told good morning.
    var gr=q('[data-ll="greet"]');
    if(gr){ var hh=new Date().getHours();
      gr.textContent = hh<5 ? 'Still up' : hh<12 ? 'Good morning' : hh<17 ? 'Good afternoon' : 'Good evening'; }
    qa('[data-ll="points"],[data-ll="points2"]').forEach(function(e){e.dataset.target=pts;e.textContent=pts.toLocaleString();});
    // tier + progress
    // TIER RESOLUTION — deliberately paranoid, and here is why.
    // The Admin API returns the tier NESTED (`loyalty_tier_membership.loyalty_tier.id`), not as a
    // flat `loyalty_tier_id`. I assumed the flat path in a checker on 23 Jul and it reported a
    // fully-imported base as "NOT DONE" — a confident false negative. This code made the SAME
    // assumption about the client SDK. If the SDK is nested too, every member silently renders as
    // Foodie: wrong tier name, wrong earn rate, wrong unlock lines, wrong ringgit conversions,
    // wrong status line. Silent, because 28162 is a perfectly valid-looking answer.
    // So: try every plausible shape, then match on name, then infer from spend, and only then
    // fall back to Foodie.
    var tm=c.loyaltyTierMembership||c.loyalty_tier_membership||{};
    var tobj=tm.loyaltyTier||tm.loyalty_tier||c.loyaltyTier||c.loyalty_tier||{};
    var tid=tm.loyaltyTierId||tm.loyalty_tier_id||tobj.id||c.loyaltyTierId||0;
    if(!tid){
      var tname=(tobj.name||tm.name||c.loyaltyTierName||'').toString().toLowerCase();
      if(tname) for(var ti=0;ti<TIERS.length;ti++)
        if(TIERS[ti].name.toLowerCase()===tname){ tid=TIERS[ti].id; break; }
    }
    if(!tid){
      // Last resort: derive from eligible spend using the SAME thresholds LoyaltyLion uses, which
      // is far better than telling a Connoisseur they're in Foodie.
      var sp0=c.loyaltyTierEligibleSpend||0, best=TIERS[0];
      for(var tj=0;tj<TIERS.length;tj++) if(sp0>=(TIERS[tj].min||0)) best=TIERS[tj];
      tid=best.id;
    }
    var ci=Math.max(0,TIERS.findIndex(function(t){return t.id===tid;}));
    // 🔴 loyaltyTierEligibleSpend is in MINOR UNITS (cents). Verified 24 Jul against a live
    // Indulgent member: SDK returned 25000, which is RM250.00 — exactly the Indulgent floor.
    // Read as ringgit it became "RM25,000 spent", so the tracker filled to 100% and told an
    // Indulgent member "Spend RM0 more to reach Connoisseur". Every member would have been told
    // they were at the top tier.
    //
    // Detected rather than blindly divided, in case the unit ever changes, and then CLAMPED into
    // the band of the tier LoyaltyLion actually assigned. The tier is authoritative; the bar must
    // never contradict the tier name sitting next to it. This also absorbs the import artifact
    // where eligible spend is seeded at the tier floor instead of true lifetime spend.
    var spend=c.loyaltyTierEligibleSpend||0;
    var _band=TIERS[ci]||TIERS[0];
    var _ceil=_band.max||_band.min||1;
    if(spend > _ceil*10) spend=spend/100;                       // clearly minor units
    if(spend < (_band.min||0)) spend=_band.min||0;               // never below the tier's own floor
    if(_band.max && spend > _band.max) spend=_band.max;          // never above it either
    var tEl=q('[data-ll="tier"]'); if(tEl)tEl.textContent=TIERS[ci].name;
    // The featured earn rate was baked from the Foodie variant, so Indulgent and Connoisseur
    // members were shown "5 per RM1" when they actually earn 7 and 10 — contradicting the tier
    // matrix further down the page. Show THEIR rate. Guests keep the "5–10" range.
    var erEl=q('[data-ll="earnrate"]'); if(erEl)erEl.textContent=TIERS[ci].rate;
    // Flavour of the Month used to be rewritten here with THIS member's exact Crumb figure and
    // what it buys. Removed 12 Aug 2026 along with the Liquid that computed it: the number came
    // from the product's price, the payout comes from a FLAT LoyaltyLion rule, and the two drift
    // apart the moment the flavour changes price. The card now states the mechanic, which is
    // true for every tier at every price and needs nothing personalised. See the comment in
    // sections/rewards-club.liquid above the flavour card.
    // fill along 3-stop bar (0->250 = first 50%, 250->1000 = next 50%)
    var fillPct=0, goal='', unlock='';
    // The unlock line used to name one perk ("Unlocks Exclusive flavour previews"), which is the
    // vaguest thing the next tier offers. The concrete thing is the earn rate, so lead with it —
    // and state it as a comparison so nobody has to hold two numbers in their head.
    // NEAREST-WIN FRAMING. Goal-gradient only motivates when the goal feels CLOSE; a big remaining
    // number discourages. And loyaltyTierEligibleSpend can be seeded at the tier floor, so "RMx
    // more" may overstate the true remaining. So: show the precise nudge ONLY when they're within
    // ~RM200 of the boundary (genuinely close + plausibly-real); otherwise frame the next tier
    // qualitatively and let the unlock line carry the reason. The nearest *reward* (the worth line
    // above) is the real, accurate near-goal doing the motivating.
    if(ci<2){
      var nextNm=TIERS[ci+1].name, toNext;
      if(ci===0){ fillPct=Math.min(50, spend/250*50); toNext=Math.max(0,250-spend); }
      else      { fillPct=50+Math.min(50,(spend-250)/750*50); toNext=Math.max(0,1000-spend); }
      goal = (toNext>0 && toNext<=200)
        ? ', just <b>RM'+toNext+'</b> more to reach '+nextNm
        : ', on your way to <b>'+nextNm+'</b>';
      unlock='🔓 '+nextNm+' earns <b>'+TIERS[ci+1].rate+' Crumbs per RM1</b> instead of '+TIERS[ci].rate+', plus '+UNLOCK[ci+1].toLowerCase();
    }
    // Top tier had a goal and then nothing — a dead end for our 1,609 best customers. Give the
    // line back to them by naming what they've got rather than what they're missing.
    else { fillPct=100; goal=", our top tier 🎉"; unlock='🏆 You earn <b>'+TIERS[2].rate+' Crumbs per RM1</b>, our best rate.'; }
    var g=q('[data-ll="goal"]'); if(g)g.innerHTML=goal;
    var u=q('[data-ll="unlock"]'); if(u)u.innerHTML=unlock;
    var f=q('[data-ll="fill"]'); if(f){ f.dataset.w=fillPct+'%'; if(reduce)f.style.width=fillPct+'%'; }
    // stops done state
    qa('.track__stop').forEach(function(s){ var si=+s.dataset.stop; s.classList.toggle('track__stop--done', si<=ci); });
    // matrix current tier highlight
    qa('.mx__head[data-tier],.mx__val[data-tier]').forEach(function(e){ e.classList.toggle('is-cur', +e.dataset.tier===ci); });
    // A CHOSEN GOAL OUTRANKS THE NEAREST REWARD. Without one the nudge points at whatever costs
    // least, which is rarely what the member actually wants. `rc_goal_v1` holds a reward id; if
    // that reward has since left the catalogue we fall back to nearest rather than showing
    // nothing. Everything below is driven by this single decision.
    // "a MYR 10 voucher" -> "RM10". The config uses a non-breaking space, so match on digits only.
    function vAmt(el){ var m=(el && el.dataset.name||'').match(/([\d.,]+)/); return m?'RM'+m[1]:''; }
    var goalCard=null;
    try{
      var gid=localStorage.getItem('rc_goal_v1');
      if(gid) goalCard=document.querySelector('.s-treats [data-rid="'+gid.replace(/"/g,'')+'"]');
    }catch(e){}
    qa('.card,.vcard').forEach(function(cd){
      var on = !!goalCard && cd===goalCard;
      cd.classList.toggle('is-goal', on);
      var gb=cd.querySelector('[data-goal]');
      if(gb){
        gb.setAttribute('aria-pressed', on?'true':'false');
        gb.querySelector('.goal__i').textContent = on?'★':'☆';
        gb.querySelector('.goal__t').textContent = on?'Your goal':'Set as my goal';
        gb.title = on?'This is your goal — tap to clear it':'Set as my goal';
      }
      var flag=cd.querySelector('.goal__flag');
      if(on && !flag){ var f=document.createElement('span'); f.className='goal__flag'; f.textContent='★ Your goal';
        (cd.querySelector('.card__img')||cd).appendChild(f); }
      else if(!on && flag){ flag.remove(); }
    });

    // affordability on reward cards
    var okc=0;
    qa('.card,.vcard').forEach(function(cd){ var cost=+cd.dataset.cost; var ok=pts>=cost;
      cd.classList.toggle('is-ok',ok); cd.classList.toggle('is-lock',!ok);
      var go=cd.querySelector('.rc__go');
      if(go){
        if(ok){
          go.textContent='Redeem'; go.classList.add('rc__go--ok');
          go.classList.remove('rc__go--tap','rc__go--plan'); go.removeAttribute('role'); go.removeAttribute('tabindex');
          okc++;
        } else {
          // Locked. Store the gap in BOTH currencies so the tap handler is pure display, and
          // convert at this member's own rate (5/7/10 per RM1) — an average would be wrong for
          // two thirds of the base. Rounded up so we never promise a treat a ringgit too early.
          var gap=cost-pts;
          go.dataset.crumbs=gap.toLocaleString()+' Crumbs to go';
          go.dataset.plan='About RM'+Math.ceil(gap/TIERS[ci].rate).toLocaleString()+' more';
          go.textContent=go.dataset.crumbs;
          go.classList.remove('rc__go--ok','rc__go--plan'); go.classList.add('rc__go--tap');
          go.setAttribute('role','button'); go.setAttribute('tabindex','0');
          go.setAttribute('aria-label',go.dataset.crumbs+' — tap to see it in ringgit');
          // A locked reward can't be redeemed. Our redeem click only fires on `.rc__go--ok`,
          // and a locked go is `.rc__go--tap`, so it never opens the redemption drawer/modal.
        }
      }
    });
    // CLAIMABLE FIRST. The catalogue is authored Premium-then-Standard, so a member holding 1,100
    // Crumbs met SEVEN locked Premium slices before reaching the eight Standard ones they could
    // actually claim — the exact deficit framing we stripped out of the copy, smuggled back in by
    // DOM order. Stable partition: the two halves keep their internal order, so Premium/Standard
    // grouping survives, and nothing moves at all when everything is affordable (Connoisseurs) or
    // nothing is (new members). Runs ~1,500px below the fold after the SDK resolves, so it can't
    // shift anything the member is looking at.
    // The chosen goal always leads, even when it's locked and everything else is claimable —
    // otherwise a goal sitting at position 12 would be hidden by the six-card collapse, and the
    // member would be tracking a reward they can't see.
    // Sorted from `data-ord` — the position the card was AUTHORED in — never from wherever the
    // DOM happens to sit now. The old version partitioned the current order in place, so once a
    // goal had moved a card to the front, clearing that goal left it there: unstarring the RM10
    // voucher did not put RM5 back in front. Sorting against a fixed origin makes every state
    // reachable from every other, in any order, forever.
    ['.s-treats .cards','.s-treats .vgrid'].forEach(function(sel){
      var grid=q(sel); if(!grid) return;
      var kids=[].slice.call(grid.children);
      kids.sort(function(a,b){
        var ag=a.classList.contains('is-goal')?0:1, bg=b.classList.contains('is-goal')?0:1;
        if(ag!==bg) return ag-bg;                                   // the goal always leads
        var ao=a.classList.contains('is-ok')?0:1, bo=b.classList.contains('is-ok')?0:1;
        if(ao!==bo) return ao-bo;                                   // then anything claimable
        return (+a.dataset.ord||0)-(+b.dataset.ord||0);             // then authored order
      });
      kids.forEach(function(k){ grid.appendChild(k); });
    });

    // A new member with a small balance would otherwise read "you can redeem 0 of these right now"
    // above a wall of locked rewards — a deficit framing at exactly the moment they need
    // encouragement. When nothing is affordable yet, point forward instead; the nudge directly
    // below already tells them precisely how close the first one is.
    var an=q('[data-ll="afford"]');
    if(an){
      // ONE FACT, AND ONLY THE ONE THAT IS NEW HERE.
      // This used to append the count to the hero's own worth sentence, producing
      // "That's 3 free cake slices, with 310 Crumbs to spare — 16 of these are yours to claim."
      // "These" then had no valid antecedent: the nearest noun is "cake slices", so it read as
      // 16 of those 3 slices, when 16 actually counts the affordable reward cards below. It
      // also put five numbers in two lines and restated, word for word, a sentence the
      // membership card already shows one screen above.
      // The count is the only thing this line knows that the hero doesn't, so it says that and
      // nothing else, and names what it is counting.
      an.innerHTML = okc>0
        ? '<b>'+okc+'</b> reward'+(okc===1?' is':'s are')+' yours to claim right now.'
        : 'You&rsquo;re at <b>'+pts.toLocaleString()+' Crumbs</b> — here&rsquo;s what they&rsquo;re building toward.';
    }
    // "YOU'RE IN THE TOP N%" — status, not money. Percentiles are real: of 78,652 buyers with a
    // lifetime-spend tier, 1,609 are Connoisseur (2%) and 17,060 are Indulgent or above (22%).
    // Foodie members are the majority, so telling them their percentile would deflate rather than
    // motivate — they get the same number framed as the thing to aim at instead.
    var rk=q('[data-ll="rank"]');
    if(rk){
      rk.innerHTML = ci===2 ? '🏆 You&rsquo;re in the top <b>4%</b> of Elevete Fam members.'
                   : ci===1 ? 'You&rsquo;re in the top <b>22%</b> of Elevete Fam members.'
                   : 'Reach Indulgent and you&rsquo;d be in the top <b>22%</b> of Elevete Fam members.';
      rk.style.display='block';
    }

    // THE MEMBER SIMULATOR. Reads the real catalogue out of the DOM, so it can never promise a
    // reward that isn't on the page, and converts at this member's own rate rather than an average.
    (function(){
      var rng=q('[data-sim="range"]'); if(!rng) return;
      var sp=q('[data-sim="spend"]'), ea=q('[data-sim="earn"]'), de=q('[data-sim="detail"]');
      var costs=[].slice.call(document.querySelectorAll('.s-treats .card,.s-treats .vcard'))
        .map(function(c){ return {cost:+c.dataset.cost, name:c.dataset.name||'a treat',
             title:(c.querySelector('.card__title')||{}).textContent}; })
        .filter(function(x){ return x.cost>0; })
        .sort(function(a,b){ return a.cost-b.cost; });
      var sliceCosts=[].slice.call(document.querySelectorAll('.s-treats .card'))
        .map(function(c){ return +c.dataset.cost; }).filter(Boolean);
      var minSliceCost=sliceCosts.length?Math.min.apply(null,sliceCosts):0;
      function upd(){
        var add=+rng.value, rate=TIERS[ci].rate, earned=Math.round(add*rate), total=pts+earned;
        if(sp) sp.textContent='RM'+add.toLocaleString();
        if(add===0){
          if(ea) ea.innerHTML='Drag to see what an order would earn you.';
          if(de) de.innerHTML='';
          return;
        }
        if(ea) ea.innerHTML='You&rsquo;d earn <b>'+earned.toLocaleString()+' Crumbs</b>'
          +' &mdash; taking you to <b>'+total.toLocaleString()+'</b>';
        // Answer in CAKE, like the hero line does. Picking the single dearest affordable reward
        // meant every total above 1,500 answered "a MYR 15 voucher" — technically the most
        // expensive thing and the least exciting, and it made the slider look broken because the
        // answer stopped changing. Slices are also ~35% COGS against a voucher's 100%.
        var bits=[], next=null;
        costs.forEach(function(x){ if(x.cost>total && (!next || x.cost<next.cost)) next=x; });
        if(minSliceCost && total>=minSliceCost){
          var n=Math.floor(total/minSliceCost), rem=total-n*minSliceCost;
          bits.push('Enough for <b>'+(n===1?'a free cake slice':n.toLocaleString()+' free cake slices')+'</b>'
                    +(rem>=100?' with '+rem.toLocaleString()+' to spare':''));
        } else if(next){
          bits.push('<b>'+(next.cost-total).toLocaleString()+' Crumbs</b> short of '+next.name);
        }
        // Would this order also move them up a tier? The strongest reason to spend a little more.
        if(ci<2){
          var nextTier=TIERS[ci+1], after=spend+add;
          if(after>=nextTier.min) bits.push('and you&rsquo;d reach <b>'+nextTier.name+'</b>');
          else bits.push('RM'+(nextTier.min-after).toLocaleString()+' more after that reaches '+nextTier.name);
        }
        if(de) de.innerHTML=bits.join(' &middot; ')+'.';
      }
      if(!rng.dataset.bound){ rng.dataset.bound='1'; rng.addEventListener('input',upd); }
      upd();
    })();

    // WHAT THE BALANCE IS WORTH. "1,100" is a number the member has to do arithmetic on; "a free
    // cake slice, with 100 Crumbs to spare" is a reason to open the app. Read from the live cards
    // rather than baked constants, so this can never contradict the catalogue further down.
    // Deliberately cake-first even when a bigger voucher is affordable: a slice costs us ~35% of
    // face where cash costs 100%, and it's the better thing to receive.
    // Computed unconditionally and stored, because the membership card is now the only place
    // this line is printed. It used to live behind `if (hero worth element exists)`, which
    // meant moving the element would have silently emptied the card instead of erroring.
    var wEl=q('[data-ll="worth"]');
    {
      var sc=[].slice.call(document.querySelectorAll('.s-treats .card')).map(function(c){return +c.dataset.cost;}).filter(Boolean);
      var vc=[].slice.call(document.querySelectorAll('.s-treats .vcard'));
      var minSlice=sc.length?Math.min.apply(null,sc):0, bestV=null, cheapV=null;
      vc.forEach(function(v){ var c=+v.dataset.cost; if(!c) return;
        if(c<=pts && (!bestV||c>bestV.c)) bestV={c:c,n:v.dataset.name||''};
        if(!cheapV||c<cheapV.c) cheapV={c:c,n:v.dataset.name||''}; });
      var rm=function(o){ var m=o&&o.n.match(/([\d.,]+)/); return m?'RM'+m[1]:'money off'; };
      var cr=function(n){ return n.toLocaleString()+' Crumb'+(n===1?'':'s'); };
      var w='';
      if(minSlice && pts>=minSlice){
        var n=Math.floor(pts/minSlice), rem=pts-n*minSlice;
        w='That&rsquo;s <b>'+(n===1?'a free cake slice':n.toLocaleString()+' free cake slices')+'</b>'
          +(rem>=100?', with '+cr(rem)+' to spare':'')+'.';
      } else if(bestV){
        w='That&rsquo;s <b>'+rm(bestV)+' off</b> your next order &mdash; or '
          +(minSlice-pts).toLocaleString()+' more for a free cake slice.';
      } else if(cheapV){
        w='<b>'+cr(cheapV.c-pts)+' more</b> and you&rsquo;ve got '+rm(cheapV)+' off your next order.';
      }
      hubWorthHTML=w||'';
      // NOTHING REWRITES THE AFFORD LINE HERE ANY MORE. This block used to run after the one
      // above and overwrite it with the hero's worth sentence plus "N of these are yours to
      // claim" — the ambiguous version. The worth sentence belongs to the membership card; the
      // Redeem tab's job is the count, which the earlier block already sets correctly.
      if(wEl){ if(w){ wEl.innerHTML=w; wEl.style.display='block'; } else { wEl.style.display='none'; } }
    }

    // CRUMBS EXPIRY — honest loss aversion, fires only when points are genuinely about to expire.
    // Shape of pointsExpiringNext is undocumented, so accept object {points,date} / number, and
    // fall back to pointsExpiryDate for the date. Threshold 60 days. Never fabricated: no real
    // expiry date within window => stays hidden (which is the case today, pre-Mar-2027).
    var xEl=q('[data-ll="expiry"]');
    if(xEl){
      var xAmt=0, xDate=null, pn=c.pointsExpiringNext;
      if(pn && typeof pn==='object'){ xAmt=pn.points||pn.amount||pn.value||0; xDate=pn.expiresAt||pn.expiryDate||pn.date||pn.expiry||c.pointsExpiryDate; }
      else if(typeof pn==='number'){ xAmt=pn; xDate=c.pointsExpiryDate; }
      var shown=false;
      if(xAmt>0 && xDate){
        var d=new Date(xDate), days=Math.ceil((d-new Date())/86400000);
        if(days>0 && days<=60){
          var rmv='RM'+(xAmt/100).toFixed(2).replace(/\.00$/,'');
          xEl.innerHTML='⏳ <b>'+xAmt.toLocaleString()+' Crumbs</b> ('+rmv+') expire on <b>'
            +d.toLocaleDateString('en-MY',{day:'numeric',month:'short'})+'</b> &mdash; a quick order keeps them.';
          xEl.style.display='block'; shown=true;
        }
      }
      if(!shown) xEl.style.display='none';
    }

    // "SINCE YOUR LAST VISIT" — the returning-member hook. Kept entirely in localStorage: no
    // backend, no LoyaltyLion call, nothing to break. Only ever shown when the balance has GONE
    // UP, so redeeming (a drop) never reads as a loss. Wrapped because storage throws in
    // private mode and this is decoration, not content.
    // The same record also carries the tier, so a CROSSING can be caught and celebrated — the
    // one genuinely rare event on this page. It outranks the "+X Crumbs" pill, so only one of
    // the two ever shows. Members stored before this shipped have no `tier`, so the first visit
    // after release records it silently and never fakes a promotion.
    try{
      var SEEN='rc_seen_v1';
      var prev=JSON.parse(localStorage.getItem(SEEN)||'null');
      var sEl=q('[data-ll="since"]'), tuEl=q('[data-ll="tierup"]');
      var tieredUp = !!(prev && typeof prev.tier==='number' && ci>prev.tier);
      if(tuEl && tieredUp){
        tuEl.innerHTML='🎉 You&rsquo;ve reached <b>'+TIERS[ci].name+'</b> — you now earn <b>'
          +TIERS[ci].rate+' Crumbs</b> on every RM1 you spend.';
        tuEl.style.display='block';
        if(!reduce) burst();
        // At the top tier the banner and the trophy line would both state the same rate. The
        // banner is the moment; the trophy line is the standing state, so it returns next visit.
        if(ci===2 && u) u.innerHTML='';
      }
      if(sEl && !tieredUp && prev && typeof prev.pts==='number' && pts>prev.pts){
        sEl.innerHTML='<b>+'+(pts-prev.pts).toLocaleString()+' Crumbs</b> since your last visit';
        sEl.style.display='block';   // own line under the greeting — never beside the balance figure
      }
      localStorage.setItem(SEEN, JSON.stringify({pts:pts, tier:ci, t:Date.now()}));
    }catch(e){}

    // "YOUR BEST TREAT RIGHT NOW" — surfaces the highest-value reward they can already afford so
    // acting is one tap instead of scrolling 18 tiles. Hidden entirely when nothing is affordable.
    // Ranked by cost, but a TIE goes to the cake, not the voucher: a slice and the RM10 voucher
    // both cost 1,000, and product costs us ~35% of face where cash costs 100% — plus a free
    // cake is the better gift and the whole point of a product-led catalogue.
    // If a goal is set and affordable it IS the best treat — otherwise the card would advertise
    // one reward while the nudge and sticky bar advertise another, which is the exact opposite of
    // what picking a goal is for.
    var bestR=null;
    if(goalCard && (+goalCard.dataset.cost)<=pts){
      var gti=goalCard.querySelector('.card__title'), gim=goalCard.querySelector('img');
      bestR={cost:+goalCard.dataset.cost, isProduct:goalCard.classList.contains('card'),
             name:(gti && gti.textContent.trim()) ? 'a free '+gti.textContent.trim() : (goalCard.dataset.name||'your goal'),
             img:gim?gim.getAttribute('src'):'', amt:vAmt(goalCard), isGoal:true};
    }
    if(!bestR) qa('.card,.vcard').forEach(function(cd){
      var cost=+cd.dataset.cost; if(cost>pts) return;
      var isProduct=cd.classList.contains('card');
      if(!bestR || cost>bestR.cost || (cost===bestR.cost && isProduct && !bestR.isProduct)){
        var im=cd.querySelector('img'), ti=cd.querySelector('.card__title');
        // Name the actual flavour. The card carried this photo already, so labelling it with the
        // generic reward title ("a free Standard cake slice") put a picture of Black Forest under
        // a line that never said Black Forest. The specific name is both truer and more appetising.
        bestR={cost:cost, isProduct:isProduct,
               name:(isProduct && ti && ti.textContent.trim()) ? 'a free '+ti.textContent.trim() : (cd.dataset.name||'a treat'),
               img:im?im.getAttribute('src'):'', amt:vAmt(cd)};
      }
    });
    var bEl=q('[data-ll="best"]');
    if(bEl){
      if(bestR){
        var nm=bestR.name.charAt(0).toUpperCase()+bestR.name.slice(1);
        var bt=q('[data-ll="bestTitle"]'); if(bt) bt.textContent=nm;
        var be=q('.best__eyebrow'); if(be) be.textContent = bestR.isGoal ? '\u2605 Your goal is ready' : 'Ready for you';
        // Naming one flavour could read as "this is your only option", so when the pick is a
        // slice, point at the other 14 sitting right below it.
        var bn=q('[data-ll="bestNote"]');
        if(bn) bn.textContent = bestR.isGoal
          ? 'The goal you picked. Claim it whenever you like.'
          : bestR.isProduct
          ? 'You have enough Crumbs. Claim it, or pick another flavour below.'
          : 'You have enough Crumbs. Claim it whenever you like.';
        // Vouchers have no photograph, and an empty 72px hole next to "Your goal is ready" looks
        // like a broken image. Draw the voucher instead — same purple tile as its card downpage.
        var bi=q('[data-ll="bestImg"]');
        if(bi){
          bi.innerHTML = bestR.img
            ? '<img src="'+bestR.img+'" alt="" loading="lazy" width="200" height="200">'
            : '<span class="best__vouch">'+(bestR.amt||'RM')+'<em>off</em></span>';
          bi.classList.toggle('best__img--v', !bestR.img);
        }
        bEl.style.display='flex';
      } else { bEl.style.display='none'; }
    }

    // NEXT-REWARD NUDGE (the "you're almost there" hook — ZUS-style near-miss motivation).
    // Finds the CHEAPEST reward still out of reach and shows the gap + a progress bar.
    // Computed here rather than baked in Liquid because the balance is only known at runtime.
    var nx=null;
    if(goalCard){
      nx={cost:+goalCard.dataset.cost,
          name:(goalCard.querySelector('.card__title')||{}).textContent
               ? goalCard.querySelector('.card__title').textContent.trim()
               : (goalCard.dataset.name||'your goal'),
          isGoal:true};
    } else {
      qa('.card,.vcard').forEach(function(cd){ var cost=+cd.dataset.cost;
        if(cost>pts && (!nx || cost<nx.cost)) nx={cost:cost, name:cd.dataset.name||'your next reward'}; });
    }
    var nu=q('[data-ll="nudge"]'), nt=q('[data-ll="nudgeText"]'), nf=q('[data-ll="nudgeFill"]');
    if(nu){
      if(nx){
        var gap=nx.cost-pts, pct=Math.max(2,Math.min(100,Math.round(pts/nx.cost*100)));
        if(nx.isGoal && gap<=0){
          // The "Your goal is ready" card sits directly above this. Saying it twice in a row is
          // noise, so the nudge stands down and lets the card carry it.
          nu.style.display='none';
          nx=null;
        }
        if(nx){
          if(nt){
            nt.innerHTML = nx.isGoal
              ? ('Your goal: <b>'+nx.name+'</b> &mdash; '+gap.toLocaleString()
                 +' Crumbs to go, about RM'+Math.ceil(gap/TIERS[ci].rate).toLocaleString()+' more.')
              : ("You're just <b>"+gap.toLocaleString()+" Crumbs</b> from "+nx.name);
          }
          if(nf){ nf.dataset.w=pct+'%'; if(reduce) nf.style.width=pct+'%'; }
          nu.style.display='flex';
        }
      } else { nu.style.display='none'; }  // can already afford everything, and no goal set
    }
    // The sticky bar becomes goal-aware too, so the target follows the member down the page.
    var sg=q('[data-ll="stickyGoal"]');
    if(sg){
      if(goalCard && (+goalCard.dataset.cost)>pts){
        sg.textContent=' · '+((+goalCard.dataset.cost)-pts).toLocaleString()+' from your goal';
        sg.style.display='inline';
      } else { sg.style.display='none'; }
    }
    // earn quest (completed rules)
    // LoyaltyLion records completed rules by ruleId (NOT kind) — completedRules entries look like
    // {ruleId: 247982}. Key the lookup by BOTH ruleId (the reliable field) and kind/string (fallback
    // for older shapes), so a claimed rule actually flips its tile to "✓ Claimed".
    var done={}; (c.completedRules||[]).forEach(function(r){
      if(r==null) return;
      if(typeof r==='string'){ done[r]=true; return; }
      if(r.ruleId!=null) done['#'+r.ruleId]=true;
      if(r.id!=null) done['#'+r.id]=true;
      if(r.kind) done[r.kind]=true;
    });
    var oneTime=['join_program','newsletter_signup','instagram_follow','facebook_like','tiktok_follow'];
    // Earn actions completed on an EXTERNAL page rather than LoyaltyLion's in-modal widget.
    // Newsletter signup is captured on our own Klaviyo landing page (branded flow).
    var EARN_URLS={newsletter_signup:'https://elevete-patisserie-m-sdn-bhd.myklpages.com/l/SbTWU5'};
    var dc=0;
    // Tile states. "Claim →" is now a TRUE affordance: an actionable tile (one carrying a rule id)
    // opens LoyaltyLion's own action widget via ui.openRuleActionModal(rid), which is what actually
    // credits the action — so the click awards correctly (previously these were plain divs with no
    // handler, so a claim link was removed as a false affordance). Automatic rules (join bonus,
    // birthday) still can't be claimed and describe themselves instead.
    var AUTO_TEXT={join_program:'Added when you join',birthday:'Lands on your birthday'};
    var claimable=0, claimed=0;
    qa('.tile[data-kind]').forEach(function(t){ var k=t.dataset.kind; var st=t.querySelector('.tile__state'); if(!st)return;
      // The referral tile is only-guest (members get the dedicated block instead). Counting it
      // gave members "2 of 6 claimed" where the 6th was invisible and unreachable from this page.
      // Never count a tile the member cannot see.
      if(t.classList.contains('only-guest')) return;
      if(EARN_URLS[k]) t.dataset.earnUrl=EARN_URLS[k];
      var isDone=!!done[k] || (t.dataset.rid && !!done['#'+t.dataset.rid]);
      // Newsletter is "done" if the account is ALREADY subscribed via any channel — checkout opt-in,
      // account-creation opt-in, or the landing page — not just the LoyaltyLion rule credit. The SDK
      // exposes this as customer.newsletter.signedUp. So a subscriber never sees "Sign up →" again;
      // the action shows claimed and attributed to their account automatically.
      if(k==='newsletter_signup' && c.newsletter && c.newsletter.signedUp) isDone=true;
      // BIRTHDAY (28 Oct 2026): state lives in the birthday module below (rcBday), which also
      // repaints this tile the moment LoyaltyLion saves a date. Tier sets the voucher amount.
      if(k==='birthday'){
        if(window.rcBday){ window.rcBday.setTier(typeof ci==='number'?ci:0); window.rcBday.paint(); }
        return;                                   // not a quest step: it pays on the day, not now
      }
      if(t.dataset.auto==='1'){
        // "Added when you join" is guest copy. The member reading it has already joined, so state
        // it as the fact it is — the tile text itself stays future-tense for guests.
        st.textContent = (k==='join_program') ? '✓ Added when you joined' : (AUTO_TEXT[k]||'Automatic');
        st.className='tile__state only-member tile__state--auto';
        if(isDone) t.classList.add('is-done');
        return;                                   // never counted as a claimable quest step
      }
      claimable++;
      if(isDone){ claimed++; st.textContent='✓ Claimed'; st.className='tile__state only-member tile__state--done'; t.classList.add('is-done'); t.classList.remove('is-claimable'); t.removeAttribute('role'); t.removeAttribute('tabindex'); if(oneTime.indexOf(k)>=0)dc++; }
      else if(t.dataset.rid || t.dataset.earnUrl){
        // Actionable: a tile with an earn URL sends the member to that page (e.g. the Klaviyo
        // newsletter signup); otherwise it opens LoyaltyLion's in-modal action. See click handler.
        var isUrl=!!t.dataset.earnUrl;
        st.textContent=isUrl?'Sign up →':'Claim →'; st.className='tile__state only-member tile__state--claim';
        t.classList.add('is-claimable'); t.setAttribute('role','button'); t.setAttribute('tabindex','0');
        t.setAttribute('aria-label',(t.querySelector('.tile__label')||{}).textContent+(isUrl?' — sign up to earn these Crumbs':' — claim these Crumbs'));
      }
      else { st.textContent='Not yet claimed'; st.className='tile__state only-member tile__state--todo'; }
    });
    var ql=q('[data-ll="quest"]');
    // "0 of 5 claimed" reads as five things you've failed to do. At zero, frame it as what's
    // available; at full, acknowledge it. The middle case is genuinely progress, so it stays.
    if(ql){
      ql.innerHTML = claimed===0
        ? 'Bonus Crumbs — <b>'+claimable+' waiting</b> for you'
        : (claimed>=claimable
            ? 'Bonus Crumbs — <b>all claimed</b>, nice work'
            : 'Bonus Crumbs — <b>'+claimed+' of '+claimable+'</b> claimed');
    }
    // Quick wins first while any remain; challenges first once they're all claimed.
    var earnPanel=club.querySelector('[data-panel="earn"]');
    if(earnPanel) earnPanel.classList.toggle('is-questdone', claimable>0 && claimed>=claimable);
    var qf=q('[data-ll="questfill"]'); if(qf){var pct=Math.round(claimed/Math.max(1,claimable)*100); qf.dataset.w=pct+'%'; if(reduce)qf.style.width=pct+'%';}

    // REFERRAL LINK. The SDK's referralUrls shape is not documented and could not be verified
    // against live data (programme was wiped/offline), so accept every plausible form and simply
    // stay hidden if none yields a URL — better an absent block than a broken one.
    var ru=c.referralUrls, link='';
    if(typeof ru==='string'){ link=ru; }
    else if(ru && typeof ru==='object'){
      link = ru.url || ru.direct || ru.link || ru.share || '';
      if(!link){ for(var k in ru){ if(typeof ru[k]==='string' && ru[k].indexOf('http')===0){ link=ru[k]; break; } } }
    }
    if(!link && c.referralUrl) link=c.referralUrl;
    var rb=q('[data-ll="refer"]'), ri=q('[data-ll="referLink"]'), rw=q('[data-ll="referWa"]');
    if(rb && link){
      if(ri) ri.value=link;
      if(rw) rw.href='https://wa.me/?text='+encodeURIComponent(SHARE_MSG+' '+link);
      rb.style.display='block';
      var cp=rb.querySelector('.refer__copy');
      if(cp && !cp.dataset.bound){
        cp.dataset.bound='1';
        cp.addEventListener('click',function(){
          var ok=function(){ cp.textContent='Copied ✓'; setTimeout(function(){cp.textContent='Copy link';},2000); };
          if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(link).then(ok,ok); }
          else { try{ ri.select(); document.execCommand('copy'); ok(); }catch(e){} }
        });
      }
    }

    // --- Goal lifecycle -> Klaviyo nudges + celebration -------------------------------
    // "Ready" fires once per goal when it first becomes affordable (powers a "your goal is ready,
    // claim it" flow). "Achieved" fires when the goal reward is actually redeemed — its id newly
    // appears in claimedRewards this session — then we clear the goal, celebrate, and let the next
    // render prompt a new one. _claimedIds starts null so nothing fires on the first load.
    try{
      var _cn=(c.claimedRewards||[]).map(function(r){return String((r.reward&&r.reward.id)||r.rewardId||r.reward_id||'');});
      if(goalCard){
        var _gid=goalCard.dataset.rid, _gcost=+goalCard.dataset.cost;
        if(_claimedIds!==null && _claimedIds.indexOf(_gid)<0 && _cn.indexOf(_gid)>=0){
          klGoal('Loyalty Goal Achieved', goalCard);
          try{ localStorage.removeItem('rc_goal_v1'); localStorage.removeItem('rc_goal_ready'); }catch(e){}
          if(!reduce) burst();
          setTimeout(function(){ if(window.__rcRender) window.__rcRender(); }, 60);
        } else if(pts>=_gcost){
          try{ if(localStorage.getItem('rc_goal_ready')!==_gid){ localStorage.setItem('rc_goal_ready', _gid); klGoal('Loyalty Goal Ready', goalCard); if(!reduce) burst(); } }catch(e){}
        }
      }
      _claimedIds=_cn;
    }catch(e){}

    // The account hub. Wrapped because it is a whole feature hanging off the same customer
    // object: a throw inside it must never take down the hero, the catalogue or the redeem
    // flow that render() has already painted above.
    try{ hubRender(c, pts, ci, spend); }
    catch(e){ if(window.console) console.warn('[sweet-club] hub render failed:',e); }

    if(!reduce) animate();
  }

  // ===================================================================================
  // YOUR ACCOUNT HUB — tabs + ledger
  // ===================================================================================
  // WHERE THE DATA COMES FROM, and why it's done this way.
  // LoyaltyLion's per-customer history is not on `loyaltylion.customer` (that object carries
  // the balance, tier, completed rules and claimed rewards, but no transaction log). The only
  // client-side surface for it is the `data-lion-history-table` component, which fetches its
  // own data straight into the SDK's redux store when it mounts. So we mount it off-screen
  // for the fetch, then take the data by whichever route works, in order of preference:
  //   A. the SDK store — structured objects, the shape we actually want;
  //   B. the component's rendered DOM — scraped into the same shape;
  //   C. failing both, we simply show LoyaltyLion's own table.
  // C matters: the member never ends up staring at an empty panel because our adapter didn't
  // recognise a payload. It's LoyaltyLion's markup, so it looks less like the page — but a
  // plain history beats no history, and the console note tells us to write a new adapter.
  // KEYED ON LOYALTYLION'S OWN RULE NAMES, NOT ON ENGLISH TITLES.
  // The API returns rule.name as a stable identifier ($purchase, $signup, $newsletter_signup…)
  // alongside rule.title, which is merchant-editable free text. Matching on the title meant a
  // rename in the LoyaltyLion dashboard would silently drop every icon back to a default;
  // matching on the name can't. Verified against a live transaction payload, 5 Aug.
  var HUB_ICON={
    '$purchase':'🛒','$signup':'🎁','$newsletter_signup':'✉️','$birthday':'🎂',
    '$instagram_follow':'📸','$facebook_like':'👍','$tiktok_follow':'🎵','$twitter_follow':'🐦',
    '$referral':'👯','$referral_complete':'👯','$review':'⭐','$product_review':'⭐',
    // resource types, for rows that aren't rule-driven
    'claimed_reward':'🍰','expiry':'⏳','adjustment':'✨','activity':'✨'};
  var hubRows=null, hubShown=0, hubFilter='all', hubBalance=0, hubWorthHTML='';

  function hubEl(k){ return club.querySelector('[data-hub="'+k+'"]'); }

  // --- Tabs. Bound once, independent of the SDK: a member whose LoyaltyLion never answers
  // still gets working navigation rather than five dead buttons. Full roving-tabindex
  // keyboard support because this is a real tablist, and the arrow keys are how a screen
  // reader user moves through one.
  // The theme's header group is itself `position:sticky`, so a tab strip pinned at top:0 parks
  // UNDERNEATH it — visible in the DOM, invisible to the member, which is worse than not sticky
  // at all. Measured at runtime rather than hard-coded: the announcement bar changes height with
  // its countdown, is a different height on desktop, and may not be there at all tomorrow.
  // Anything pinned in the top 40% of the viewport counts as chrome; below that it's content.
  function hubTopChrome(){
    // The chrome is a STACK, not one bar: this theme pins the announcement bar (64px) and the
    // header (a further 42px) as two separate sticky sections. Sampling only the top few pixels
    // finds the announcement and stops, which parks the tab strip behind the header — so we
    // climb the viewport in small steps and keep the LOWEST pinned edge, stopping at the first
    // gap where nothing is pinned any more.
    var h=0, x=Math.round(innerWidth/2), limit=innerHeight*0.4;
    for(var y=2; y<limit; y+=12){
      if(y>h+14) break;                                   // past the bottom of the pinned stack
      var els=document.elementsFromPoint(x,y)||[];
      for(var i=0;i<els.length;i++){
        for(var n=els[i]; n && n!==document.body; n=n.parentElement){
          if(n.closest && n.closest('.rc-club')) break;    // never measure ourselves
          var p=getComputedStyle(n).position;
          if(p==='fixed'||p==='sticky'){
            var b=n.getBoundingClientRect().bottom;
            if(b>h && b<limit) h=b;
            break;
          }
        }
      }
    }
    return Math.round(h);
  }
  function hubSetTop(){
    try{ club.style.setProperty('--hub-top', hubTopChrome()+'px'); }catch(e){}
  }

  (function hubTabs(){
    var strip=club.querySelector('.hub__tabs'); if(!strip) return;
    var tabs=[].slice.call(strip.querySelectorAll('.hub__tab'));
    // Measure once now, again after the header has settled, and on resize/orientation change.
    // A couple of early scroll samples catch themes whose header condenses on first scroll.
    hubSetTop();
    var samples=0;
    addEventListener('scroll',function onScroll(){
      if(++samples>3){ removeEventListener('scroll',onScroll); return; }
      requestAnimationFrame(hubSetTop);
    },{passive:true});
    addEventListener('resize',hubSetTop,{passive:true});
    addEventListener('orientationchange',hubSetTop,{passive:true});
    function select(name, focus){
      tabs.forEach(function(t){
        var on=t.dataset.tab===name;
        t.setAttribute('aria-selected', on?'true':'false');
        t.tabIndex = on?0:-1;
        if(on && focus) t.focus();
      });
      club.querySelectorAll('.hub__panel').forEach(function(p){ p.hidden = p.dataset.panel!==name; });
      // Hash, not localStorage: a member can send "look at my rewards tab" to a friend, and a
      // reload lands them back where they were. replaceState so the back button still leaves
      // the page rather than walking back through five tab presses.
      try{ history.replaceState(null,'', '#rc-'+name); }catch(e){}
    }
    strip.addEventListener('click',function(ev){
      var t=ev.target.closest('.hub__tab'); if(!t) return;
      select(t.dataset.tab, false);
      // Bring the strip back into view on mobile, where the previous panel may have been
      // scrolled well past. Scrolled by hand rather than scrollIntoView() so it lands BELOW the
      // theme's sticky header instead of behind it.
      var off=parseInt(getComputedStyle(club).getPropertyValue('--hub-top'),10)||0;
      var r=strip.getBoundingClientRect();
      if(r.top<off) scrollTo({top:scrollY+r.top-off, behavior:reduce?'auto':'smooth'});
    });
    strip.addEventListener('keydown',function(ev){
      var i=tabs.indexOf(document.activeElement); if(i<0) return;
      var n=null;
      // Both axes: the same tablist is a horizontal scroller on mobile and a vertical rail on
      // desktop, and a keyboard user on the rail reaches for the up/down keys.
      if(ev.key==='ArrowRight' || ev.key==='ArrowDown') n=(i+1)%tabs.length;
      else if(ev.key==='ArrowLeft' || ev.key==='ArrowUp') n=(i-1+tabs.length)%tabs.length;
      else if(ev.key==='Home') n=0;
      else if(ev.key==='End') n=tabs.length-1;
      if(n===null) return;
      ev.preventDefault(); select(tabs[n].dataset.tab, true);
    });
    // Rewards is the landing tab: someone opening their account wants what they can have, not
    // a breakdown of what they've done. A hash still wins, so shared links keep working.
    var h=(location.hash||'').replace('#rc-','');
    if(h && tabs.some(function(t){return t.dataset.tab===h;})) select(h,false);
    else select('redeem', false);
    // URGENCY OUTRANKS MERCHANDISING. A member holding an unused reward was landing on Redeem,
    // being sold another one, while the thing they already own expired a tab away. Once the
    // rewards tab knows it has live rewards it takes the landing slot — unless a hash asked
    // for something specific, which is always an explicit request.
    // `h` is read BEFORE the first select(), which writes the hash itself via replaceState —
    // checking location.hash later would always look like an explicit request and the routing
    // would never fire.
    var askedFor = h && tabs.some(function(t){return t.dataset.tab===h;});
    window.__rcLandOnRewards=function(){ if(!askedFor) select('rewards', false); };
  })();

  // --- Filter pills
  // In-page links to a tab (#rc-earn, #rc-treats…) did nothing: the hash is only read at load.
  // Route any of them through the tab buttons so they actually navigate.
  (function hubHashLinks(){
    club.addEventListener('click',function(ev){
      var a=ev.target.closest('a[href^="#rc-"]'); if(!a) return;
      var name=a.getAttribute('href').replace('#rc-','');
      var map={earn:'earn',treats:'redeem',hub:'redeem'};
      var t=club.querySelector('[data-tab="'+(map[name]||name)+'"]');
      if(!t) return;
      ev.preventDefault(); t.click();
      var strip=club.querySelector('.hub__tabs');
      if(strip){ var off=parseInt(getComputedStyle(club).getPropertyValue('--hub-top'),10)||0;
        var r=strip.getBoundingClientRect();
        scrollTo({top:scrollY+r.top-off-8, behavior:reduce?'auto':'smooth'}); }
    });
  })();

  (function hubPills(){
    var wrap=club.querySelector('.hub__pills'); if(!wrap) return;
    wrap.addEventListener('click',function(ev){
      var b=ev.target.closest('.hub__pill'); if(!b) return;
      hubFilter=b.dataset.filter;
      wrap.querySelectorAll('.hub__pill').forEach(function(p){ p.setAttribute('aria-pressed', p===b?'true':'false'); });
      hubShown=0; paintLedger();
    });
  })();

  (function hubMore(){
    var b=hubEl('ledgerMore'); if(!b) return;
    b.addEventListener('click',function(){ hubShown+=20; paintLedger(true); });
  })();

  // --- A: the SDK store. Shape is undocumented and has changed before, so rather than
  // hard-coding a path we look for the first array of objects that *behaves* like history:
  // something with a date and a points figure on every row. Bounded to two levels so this
  // can never walk a large graph.
  function historyFromStore(){
    try{
      var st=window.loyaltylion && window.loyaltylion.ui && window.loyaltylion.ui.store;
      if(!st || typeof st.getState!=='function') return null;
      var state=st.getState()||{}, found=null;
      function looksLikeHistory(a){
        if(!Array.isArray(a) || !a.length) return false;
        var r=a[0]; if(!r || typeof r!=='object') return false;
        var hasDate = 'createdAt' in r || 'created_at' in r || 'date' in r || 'occurredAt' in r;
        var hasPts  = 'points' in r || 'pointsApproved' in r || 'amount' in r || 'value' in r;
        return hasDate && hasPts;
      }
      function scan(o,d){
        if(found || !o || typeof o!=='object' || d>2) return;
        for(var k in o){
          var v;
          try{ v=o[k]; }catch(e){ continue; }
          if(looksLikeHistory(v)){ found=v; return; }
          if(v && typeof v==='object' && !Array.isArray(v)) scan(v,d+1);
        }
      }
      scan(state,0);
      if(!found) return null;
      return found.map(fromApiRow);
    }catch(e){ return null; }
  }

  // THE DOCUMENTED TRANSACTION MODEL (Admin API v2, /customers/{id}/transactions).
  // Every row is one of four resources — activity, claimed_reward, adjustment, expiry — and
  // carries signed points_approved / points_pending deltas plus created_at. An `activity` row
  // nests the rule, and a purchase nests the order (merchant_number, total, refund status),
  // which is why the Orders tab needs no Liquid order access at all.
  // Written against the published OpenAPI schema and checked against a live payload rather
  // than guessed, and it accepts both snake_case (API) and camelCase (SDK) spellings, since
  // the client SDK serves the same domain model with different casing.
  function pick(o){
    for(var i=1;i<arguments.length;i++){
      var k=arguments[i];
      if(o && o[k]!==undefined && o[k]!==null) return o[k];
    }
    return null;
  }
  // THE CLIENT-SIDE SHAPE, confirmed 5 Aug against a live member session.
  // The SDK does NOT serve the Admin API's transaction objects. Its history lives at
  //   loyaltylion.ui.store.getState().customer.actions
  // with a flatter, differently-named shape:
  //   { id, type, date, points, approveDate, completedRuleId, ruleId, state, ruleKind,
  //     ruleTitle, expiresAt }
  // Three differences that mattered: the timestamp is `date` (not created_at), the points are
  // `points` (not points_approved), and the rule identifier is `ruleKind` WITHOUT the dollar
  // prefix the Admin API uses ("purchase", not "$purchase"). The first would have left every
  // row dateless; the third would have dropped every icon and statement title.
  // Both spellings are handled so the same code reads either source.
  function ruleKey(k){
    k=(k||'').toString();
    return k.charAt(0)==='$' ? k : (k ? '$'+k : '');
  }
  function fromApiRow(r){
    var rawType = (pick(r,'resource','type','kind') || 'activity').toString().toLowerCase();
    var res = /reward/.test(rawType) ? 'claimed_reward'
            : /transaction|adjust/.test(rawType) ? 'adjustment'
            : /expir/.test(rawType) ? 'expiry'
            : rawType || 'activity';
    var act = pick(r,'activity') || {};
    var cr  = pick(r,'claimed_reward','claimedReward') || {};
    var rule= pick(act,'rule') || pick(r,'rule') || {};
    var ord = pick(act,'order') || pick(r,'order') || {};

    // Points. A transaction states approved and pending separately and either can be the
    // meaningful figure (a purchase lands as pending, then converts). Fall back to the
    // activity's own `value`, which is what the activities endpoint returns.
    var ap = +pick(r,'points_approved','pointsApproved') || 0;
    var pe = +pick(r,'points_pending','pointsPending') || 0;
    var pts = ap || pe || +pick(act,'value') || +pick(r,'value','points','amount') || 0;
    // A claimed reward is a cost, and the API reports point_cost unsigned.
    var cost = +pick(cr,'point_cost','pointCost') || 0;
    if(res==='claimed_reward'){
      // Unsigned on both sources: the Admin API reports point_cost, the SDK reports a positive
      // `points`. Either way a redemption is money out.
      var spend = cost || Math.abs(pts);
      if(spend>0) pts = -spend;
    }

    // State. The documented enum is pending | declined | approved | void | expired — `expired`
    // was missing from the first cut and would have rendered as a normal approved row.
    var st = (pick(act,'state') || pick(cr,'state') || pick(r,'state','status') || 'approved')
             .toString().toLowerCase();

    return normaliseRow({
      // `date` is the SDK's field; created_at is the Admin API's.
      ts: pick(r,'created_at','createdAt','date','occurredAt') || pick(act,'created_at','createdAt'),
      points: pts,
      state: st,
      resource: res,
      // rule.name is the Admin API's ($purchase); ruleKind is the SDK's (purchase).
      ruleName: ruleKey(pick(rule,'name') || pick(r,'ruleKind','rule_kind') || ''),
      title: pick(rule,'title') || pick(r,'ruleTitle','rule_title')
             || (pick(cr,'reward') && pick(pick(cr,'reward'),'title'))
             || pick(r,'title','name') || '',
      note: pick(pick(r,'adjustment') || pick(r,'expiry') || {}, 'note') || '',
      ref: pick(ord,'merchant_number','merchantNumber') || ''
    });
  }

  // --- B: the component's own DOM. Class names are LoyaltyLion's and could change, so the
  // parser leans on structure and text rather than exact selectors: any row-ish element that
  // contains a signed points figure counts. State is read from the `history-state-bubble--x`
  // modifier the bundle ships, with a text fallback.
  function historyFromDom(){
    var src=hubEl('historySrc'); if(!src) return null;
    var nodes=src.querySelectorAll('tr,li,[class*="history-table__row"],[class*="row"]');
    var out=[];
    [].slice.call(nodes).forEach(function(n){
      if(n.querySelector('tr,li')) return;                     // containers, not rows
      var txt=(n.textContent||'').replace(/\s+/g,' ').trim();
      if(!txt) return;
      var m=txt.match(/([+-]\s?[\d,]+)\s*(?:points|crumbs)?/i);
      if(!m) return;
      var pts=+m[1].replace(/[\s,]/g,'');
      if(!pts && !/0/.test(m[1])) return;
      var st='approved';
      var bub=n.querySelector('[class*="history-state-bubble--"]');
      if(bub){ var c=(bub.className.match(/history-state-bubble--([a-z]+)/)||[])[1]; if(c) st=c; }
      else if(/pending/i.test(txt)) st='pending';
      else if(/void|refund/i.test(txt)) st='void';
      else if(/declin/i.test(txt)) st='declined';
      var dm=txt.match(/(\d{1,2}\s+\w{3,}\s+\d{4}|\w{3,}\s+\d{1,2},?\s+\d{4}|\d{4}-\d{2}-\d{2})/);
      out.push(normaliseRow({
        ts: dm?dm[1]:null,
        points: pts,
        state: st,
        resource: pts<0 ? 'claimed_reward' : 'activity',
        ruleName: '',
        title: txt.replace(m[0],'').replace(dm?dm[1]:'','').replace(/\s+/g,' ').trim().slice(0,70),
        ref: (txt.match(/#\d+/)||[''])[0]
      }));
    });
    return out.length?out:null;
  }

  // Titles from LoyaltyLion are functional ("Make a purchase"); the ones a member reads on
  // their own statement should say what happened to THEM. Kept as a small map rather than a
  // rewrite of every string, so anything unmapped still shows LoyaltyLion's own wording.
  // Statement wording. LoyaltyLion's rule titles are instructions to the customer ("Make a
  // purchase", "Leave a review") — correct on an earn tile, wrong on a statement, where the
  // thing already happened. Keyed on the stable rule name so a dashboard rename can't undo it;
  // anything unmapped falls through to LoyaltyLion's own title rather than to a guess.
  var HUB_TITLE={'$purchase':'Order','$signup':'Joined Elevete Fam',
    '$newsletter_signup':'Joined the mailing list','$instagram_follow':'Followed on Instagram',
    '$facebook_like':'Liked on Facebook','$tiktok_follow':'Followed on TikTok',
    '$twitter_follow':'Followed on X','$birthday':'Birthday treat',
    '$referral':'Friend referred','$referral_complete':'Friend referred',
    '$review':'Review left','$product_review':'Review left'};
  function normaliseRow(r){
    var t=(r.title||'').trim();
    var rn=(r.ruleName||'').trim();
    var res=(r.resource||'activity');
    var d = r.ts ? new Date(r.ts) : null;
    if(d && isNaN(d.getTime())) d=null;
    // Icon: rule first (a purchase is a trolley whatever the merchant calls the rule), then
    // the resource type for rows that aren't rule-driven.
    var icon = HUB_ICON[rn] || HUB_ICON[res] || (r.points<0?'🍰':'✨');
    var title = HUB_TITLE[rn] || t
      || (res==='claimed_reward' ? 'Reward claimed'
         : res==='expiry' ? 'Crumbs expired'
         : res==='adjustment' ? (r.note||'Adjustment')
         : (r.points<0?'Crumbs spent':'Crumbs added'));
    return { ts:d, points:+r.points||0, state:(r.state||'approved').toLowerCase(),
             kind:res, ruleName:rn, icon:icon, title:title, note:r.note||'', ref:r.ref||'' };
  }

  function hubDate(d){
    if(!d) return '';
    return d.toLocaleDateString('en-MY',{day:'numeric',month:'short',year:'numeric'});
  }

  // ---- MY REWARDS ---------------------------------------------------------------------
  // Reads customer.claimedRewards. The Admin API documents a claimed reward as
  //   { id, claimed_at, point_cost, redeemable, reward{title}, state, expires_at, auto_refund_at }
  // and the SDK serves the same domain model in camelCase, so both spellings are accepted —
  // the same lesson the history adapter learned the hard way.
  // `redeemable` is where the discount code lives; without it there is nothing to copy and the
  // card falls back to sending the member to checkout, which is still true and still useful.
  function rwState(r){
    var s=(pick(r,'state','status')||'').toString().toLowerCase();
    if(/void|refund/.test(s)) return 'refunded';
    if(/used|redeemed|spent/.test(s)) return 'used';
    if(/expired/.test(s)) return 'expired';
    var exp=pick(r,'expires_at','expiresAt');
    if(exp && new Date(exp) < new Date()) return 'expired';
    return 'live';
  }
  function rwCode(r){
    var red=pick(r,'redeemable') || {};
    return pick(red,'code','discount_code','discountCode') || pick(r,'code','discount_code','discountCode') || '';
  }
  function paintRewards(c){
    var live=hubEl('rwActive'), past=hubEl('rwPast'), wrap=hubEl('rwPastWrap'),
        lead=hubEl('rwLead'), cnt=hubEl('rewardsCount');
    if(!live) return;
    var all=(c && (c.claimedRewards||c.claimed_rewards)) || [];
    var A=[], P=[];
    all.forEach(function(r){
      var rw=pick(r,'reward') || {};
      var row={
        title: pick(rw,'title','name') || pick(r,'title','name') || 'Reward',
        cost:  +pick(r,'point_cost','pointCost','pointsCost') || 0,
        code:  rwCode(r),
        state: rwState(r),
        claimed: pick(r,'claimed_at','claimedAt','created_at','createdAt'),
        expires: pick(r,'expires_at','expiresAt')
      };
      (row.state==='live' ? A : P).push(row);
    });
    if(cnt) cnt.textContent = A.length ? '('+A.length+')' : '';

    function card(r, isPast){
      var d = r.expires ? new Date(r.expires) : null;
      var days = d && !isNaN(d) ? Math.ceil((d-new Date())/86400000) : null;
      var meta=[];
      if(r.cost>0) meta.push(r.cost.toLocaleString()+' Crumbs');
      if(!isPast && days!=null && days>0) meta.push(days<=14 ? '<b style="color:var(--purple)">Use within '+days+' day'+(days===1?'':'s')+'</b>' : 'Expires '+d.toLocaleDateString('en-MY',{day:'numeric',month:'short'}));
      if(isPast) meta.push(r.state==='used'?'Used':r.state==='refunded'?'Refunded':'Expired');
      return '<div class="rwcard'+(isPast?'':' rwcard--live')+'">'
        +'<div class="rwcard__top"><div class="rwcard__t">'+r.title+'</div></div>'
        +(r.code && !isPast
            ? '<div class="rwcode"><span class="rwcode__v">'+r.code+'</span>'
              +'<button class="rwcode__b" type="button" data-code="'+r.code+'">Copy</button></div>'
            : '')
        +'<div class="rwcard__meta">'+meta.join(' &middot; ')+'</div>'
        +(!isPast ? '<a class="btn btn--primary rwcard__cta" href="/collections">Use it on an order</a>' : '')
        +'</div>';
    }

    live.innerHTML = A.map(function(r){ return card(r,false); }).join('');
    if(past) past.innerHTML = P.map(function(r){ return card(r,true); }).join('');
    if(wrap){
      wrap.style.display = P.length ? 'block' : 'none';
      var pc=hubEl('rwPastCount'); if(pc) pc.textContent = P.length+' past reward'+(P.length===1?'':'s');
    }

    if(!A.length){
      // Never an empty box on the landing tab. If nothing is claimed, point at the catalogue
      // with the member's own balance, which is the reason they'd go there.
      var pts=hubBalance||0;
      live.innerHTML='<div class="hub__empty" style="grid-column:1/-1">'
        +'<span class="hub__empty__i">🍰</span>'
        +'<div class="hub__empty__t">Nothing claimed yet</div>'
        +'<p class="hub__empty__d">You have <b>'+pts.toLocaleString()+' Crumbs</b> waiting. '
        +'Swap them for a free cake slice or money off your next order.</p>'
        +'<a class="btn btn--primary" data-redeem href="#rc-treats">See what you can get</a></div>';
    }
    if(lead){
      lead.innerHTML = A.length
        ? 'You have <b>'+A.length+' reward'+(A.length===1?'':'s')+'</b> ready to use. Codes apply at checkout.'
        : '';
      lead.style.display = A.length ? 'block' : 'none';
    }
    // Only claim the landing slot when something is actually waiting to be used.
    if(A.length && window.__rcLandOnRewards){
      try{ window.__rcLandOnRewards(); window.__rcLandOnRewards=null; }catch(e){}
    }
  }
  // Copy handler, delegated once so it survives every re-render.
  (function(){
    var panel=club.querySelector('[data-panel="rewards"]'); if(!panel) return;
    panel.addEventListener('click',function(ev){
      var b=ev.target.closest('.rwcode__b'); if(!b) return;
      var code=b.dataset.code||'';
      var ok=function(){ b.textContent='Copied ✓'; setTimeout(function(){ b.textContent='Copy'; },2000); };
      if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(ok,ok); }
      else { try{ var t=document.createElement('textarea'); t.value=code; document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove(); ok(); }catch(e){} }
    });
  })();


  // ---- BADGES ---------------------------------------------------------------------------
  // Orders and flavours come from Liquid (order history is server-side only); reviews,
  // referrals and redemptions come from the LoyaltyLion customer. Rule matching is on the
  // stable ruleKind/name, same as everywhere else.
  function paintBadges(c){
    var host=hubEl('badges'), pass=hubEl('passport'); if(!host) return;
    var orders=+(pass&&pass.dataset.orders)||0,
        flav=+(pass&&pass.dataset.flavours)||0,
        flavTotal=+(pass&&pass.dataset.flavoursTotal)||13;
    var done={};
    (c.completedRules||[]).forEach(function(r){
      var k=r&&(r.ruleKind||r.kind||''); if(k) done[ruleKey(k)]=true;
      if(r&&r.ruleId!=null) done['#'+r.ruleId]=true;
    });
    // The ledger is the more reliable witness for one-off actions, since completedRules only
    // carries rules the SDK knows are repeatable-complete.
    (hubRows||[]).forEach(function(r){ if(r.state==='approved'&&r.ruleName) done[r.ruleName]=true; });
    var claimed=((c.claimedRewards||c.claimed_rewards)||[]).length;

    // Each milestone states where you are, not just whether you're done. Same shape as a
    // LoyaltyLion challenge, so these can be swapped for real ones once they're configured.
    var LIST=[
      {i:'\ud83c\udf70', n:'First taste',      have:Math.min(orders,1),  need:1},
      {i:'\ud83d\udd90\ufe0f', n:'Five orders', have:Math.min(orders,5),  need:5},
      {i:'\ud83d\udd1f', n:'Ten orders',      have:Math.min(orders,10), need:10},
      {i:'\ud83d\udc51', n:'Twenty-five',     have:Math.min(orders,25), need:25},
      {i:'\u2b50', n:'Leave a review',        have:(done['$review']||done['$product_review'])?1:0, need:1},
      {i:'\ud83d\udc6f', n:'Refer a friend',  have:(done['$referral']||done['$referral_complete'])?1:0, need:1},
      {i:'\ud83c\udf81', n:'First redemption',have:Math.min(claimed,1), need:1},
      {i:'\ud83c\udf08', n:'Five flavours',   have:Math.min(flav,5),    need:5},
      {i:'\ud83c\udfc5', n:'Every flavour',   have:flav,                need:flavTotal||13}
    ];
    var got=0;
    host.innerHTML=LIST.map(function(b){
      var on=b.have>=b.need; if(on) got++;
      var pct=Math.max(0,Math.min(100,Math.round(b.have/b.need*100)));
      return '<li class="bdg'+(on?' is-on':'')+'">'
        +'<span class="bdg__i" aria-hidden="true">'+b.i+'</span>'
        +'<span class="bdg__c"><span class="bdg__n">'+b.n+'</span>'
        +'<span class="bdg__bar"><span class="bdg__fill" style="width:'+pct+'%"></span></span>'
        +'<span class="bdg__p">'+(on?'Done':b.have+' of '+b.need)+'</span></span></li>';
    }).join('');
    var cnt=hubEl('badgeCount');
    if(cnt) cnt.innerHTML='<b>'+got+'</b> of '+LIST.length+' unlocked';
  }


  // ---- REAL CHALLENGES ------------------------------------------------------------------
  // Shape is unverified (both challenges are Draft, so customer.challenges is empty until one
  // goes Active). Every field is read through pick() with the plausible spellings, and the
  // first payload is logged once so the shape can be confirmed the moment one is published.
  function paintChallenges(c){
    var host=hubEl('challenges'), block=hubEl('chblock'); if(!host) return;
    var list=pick(c,'challenges','activeChallenges') || [];
    if(!list.length){ if(block) block.style.display='none'; return; }
    // How many orders this customer has ever placed, rendered server-side onto the passport.
    // Used only to decide whether the "starts from today" note is worth showing: somebody with
    // no order history has nothing to reconcile and should not be told about it.
    var priorOrders = (function(){
      var el = club.querySelector('.fpwrap[data-orders]');
      return el ? (+el.getAttribute('data-orders') || 0) : 0;
    })();
    host.innerHTML=list.map(function(ch){
      // LoyaltyLion's own model, read from their bundle: a challenge is a STAMP CARD, not a
      // progress bar. Their fields are milestones[] with target + state, a counter for where
      // the member is, and states locked | in_progress | complete. Their i18n keys are
      // stamp_order / stamp_referral / stamp_review, next_milestone_reward, to_go — so the UI
      // here mirrors that vocabulary rather than inventing a parallel one.
      // Milestones are NOT always on the challenge. LoyaltyLion's own renderer takes them from
      // a SEGMENT (`({segment, journey}) => hr(segment.milestones, segment.counter)`), so a flat
      // read returned undefined and the card claimed "Card full" on an empty array — reported
      // live, showing 0/0. Find the first array anywhere in the object whose items look like
      // milestones, so the shape can nest however LoyaltyLion likes.
      // ✅ SHAPE VERIFIED 11 Aug 2026, against both live ladders. Milestones are NOT on the
      // challenge object. They sit at challenge.segments[].milestones[], each segment carrying
      // its own `counter`, and each milestone using `at` for the threshold plus `label`,
      // `state` ("upcoming" | "complete") and a nested `outcome:{kind:"points",points:N}`.
      // Each ladder has TWO segments: the real one ("Milestones", milestone kind) and an
      // "Ongoing bonus" segment whose single milestone is kind:"recurring". The recurring one
      // is not a rung and must never be drawn as one.
      // WHY THIS WAS REWRITTEN: the previous generic finder rejected any array whose FIRST item
      // lacked target/threshold/state, and returned null instead of descending into the array's
      // items. challenge.segments[0] has none of those keys, so it bailed — which is why every
      // published challenge rendered as a bare title and description with no stamps at all.
      function ladderOf(o){
        var segs = Array.isArray(o && o.segments) ? o.segments : [];
        for(var i=0;i<segs.length;i++){
          var s=segs[i];
          var ms = Array.isArray(s && s.milestones) ? s.milestones.filter(function(m){
            return (pick(m,'kind','type') || 'milestone').toString().toLowerCase() !== 'recurring';
          }) : [];
          if(ms.length) return { ms: ms, counter: +(s.counter || 0) };
        }
        // Flat spellings kept as a fallback so a future shape change degrades instead of blanking.
        var flat = (o && (o.milestones || o.steps || o.levels)) || [];
        return (Array.isArray(flat) && flat.length)
          ? { ms: flat, counter: +(pick(o,'counter','progress','current') || 0) } : null;
      }
      var lad = ladderOf(ch);
      var ms = lad ? lad.ms : [];
      // A challenge with no milestones we can read is NOT a finished one. Say nothing rather
      // than congratulate someone for a card they never filled.
      if(!ms.length){
        if(window.console) console.warn('[sweet-club] no milestones found on challenge:', Object.keys(ch));
        return '<div class="ch"><div class="ch__head"><span class="ch__eyebrow">'
          +(pick(ch,'title','displayTitle','name')||'Challenge')+'</span></div>'
          +((pick(ch,'description','subtitle'))?'<p class="ch__d">'+pick(ch,'description','subtitle')+'</p>':'')
          +'</div>';
      }
      var title=pick(ch,'title','displayTitle','name') || 'Challenge';
      var desc=pick(ch,'description','subtitle') || '';
      // The counter belongs to the SAME segment as the milestones — never to the challenge, and
      // never to the other segment, whose counter tracks the recurring bonus instead.
      var counter = lad ? lad.counter : 0;
      var kind=(pick(ch,'kind','type','challengeType')||'').toString().toLowerCase();
      var unit = (/refer/.test(kind)||/refer|friend/i.test(title)) ? 'referral'
               : (/review/.test(kind)||/review/i.test(title)) ? 'review' : 'order';

      var stamps=ms.map(function(m,i){
        // `at` is LoyaltyLion's real field name for the threshold; the rest are fallbacks.
        var target=+(pick(m,'at','target','threshold','count','value','requirement') || (i+1));
        var st=(pick(m,'state','status')||'').toString().toLowerCase();
        var done = st==='complete' || st==='completed' || !!pick(m,'achieved','completed')
                   || (counter>0 && counter>=target);
        // The payout is nested: outcome:{kind:'points',points:N}. A flat read found nothing, so
        // every rung showed its order number instead of what it actually pays.
        var rw=pick(m,'reward','rewardTitle','points','amount','pointsAmount');
        var oc=pick(m,'outcome');
        if(rw==null && oc && typeof oc==='object') rw=pick(oc,'points','amount','title','name');
        if(rw && typeof rw==='object') rw=pick(rw,'title','name','points','amount');
        return {target:target, done:done, inProgress:st==='in_progress',
                label:pick(m,'name','title','label')||'', reward:rw};
      }).sort(function(a,b){ return a.target-b.target; });

      var nextI=stamps.findIndex(function(x){ return !x.done; });
      var allDone=nextI<0;
      var got=stamps.filter(function(x){return x.done;}).length;

      var lead;
      if(allDone){
        lead='<b>Card full</b>Every '+unit+' from here keeps earning the ongoing bonus.';
      } else {
        var nx=stamps[nextI], gap=Math.max(1,nx.target-counter);
        var rw=nx.reward!=null ? (isNaN(+nx.reward)? String(nx.reward) : (+nx.reward).toLocaleString()+' Crumbs')
                               : (nx.label||'the next stamp');
        lead='<b>'+gap+' more '+unit+(gap===1?'':'s')+'</b> and <em>'+rw+'</em> is yours.';
      }

      var row=stamps.map(function(x,i){
        var cls = x.done ? 'is-done' : (i===nextI ? 'is-next' : 'is-locked');
        var val = x.reward!=null && !isNaN(+x.reward)
          ? (+x.reward>=1000 ? (+x.reward/1000)+'k' : x.reward) : x.target;
        return '<div class="stamp '+cls+'">'
          +'<span class="stamp__d">'+(x.done?'&check;':val)+'</span>'
          +'<span class="stamp__l">'+(x.label||(unit+' '+x.target))+'</span></div>';
      }).join('');

      return '<div class="ch'+(allDone?' is-done':'')+'">'
        +'<div class="ch__head"><span class="ch__eyebrow">'+title+'</span>'
        +'<span class="ch__frac">'+got+'/'+stamps.length+'</span></div>'
        +(desc?'<p class="ch__d">'+desc+'</p>':'')
        +'<p class="ch__lead">'+lead+'</p>'
        +'<div class="stamps">'+row+'</div>'
        // Only on an ORDER ladder, only at zero progress, only for someone who has ordered
        // before. A referral ladder has no history to honour, and a first-time member reading
        // "your tier already counts everything you've ordered" would just be confused.
        +((unit==='order' && counter===0 && priorOrders>0)
            ? '<p class="ch__note">This ladder starts from today. Your tier already counts '
              +'everything you&rsquo;ve ordered.</p>'
            : '')
        +'</div>';
    }).join('');
    host.style.display='grid';
    if(block) block.style.display='block';
    try{ paintMission(list); }catch(e){ if(window.console) console.warn('[sweet-club] mission strip failed:',e); }
    // One source of truth: real challenges retire the hand-built milestones block.
  }


  // The hero strip. Shows ONE challenge — the one closest to its next stamp — because two
  // competing goals is no goal. Everything else stays in the Earn tab.
  function paintMission(list){
    var strip=hubEl('mission'); if(!strip) return;
    var best=null;
    (list||[]).forEach(function(ch){
      var ms=(function find(o,d){
        if(!o||typeof o!=='object'||d>3) return null;
        if(Array.isArray(o)) return (o.length&&o[0]&&('target' in o[0]||'threshold' in o[0]||'state' in o[0]))?o:null;
        var dir=o.milestones||o.steps||o.levels; if(Array.isArray(dir)&&dir.length) return dir;
        for(var k in o){ var v; try{v=o[k];}catch(e){continue;} var h=find(v,d+1); if(h) return h; }
        return null;
      })(ch,0) || [];
      if(!ms.length) return;
      var counter=+(pick(ch,'counter','progress','current','count')||0);
      var steps=ms.map(function(m,i){
        var t=+(pick(m,'target','threshold','count','value')||(i+1));
        var st=(pick(m,'state','status')||'').toString().toLowerCase();
        return {t:t, done: st==='complete'||st==='completed'||!!pick(m,'achieved','completed')||(counter>0&&counter>=t)};
      }).sort(function(a,b){return a.t-b.t;});
      var ni=steps.findIndex(function(x){return !x.done;});
      if(ni<0) return;                                    // finished cards don't nag
      var gap=Math.max(1, steps[ni].t-counter);
      var title=pick(ch,'title','displayTitle','name')||'Challenge';
      var kind=(pick(ch,'kind','type')||'').toString().toLowerCase();
      var unit=(/refer/.test(kind)||/refer|friend/i.test(title))?'referral':(/review/.test(kind)?'review':'order');
      if(!best || gap<best.gap) best={gap:gap, title:title, unit:unit, steps:steps, next:ni};
    });
    if(!best){ strip.style.display='none'; return; }
    hubEl('missionTitle').textContent=best.title;
    hubEl('missionGap').innerHTML='<b>'+best.gap+'</b> more '+best.unit+(best.gap===1?'':'s')+' to your next stamp';
    var hint=hubEl('missionHint');
    if(hint){
      var collected=best.steps.filter(function(x){return x.done;}).length;
      // Somebody who has collected nothing has never seen a stamp card and shouldn't have to
      // work out what the dots mean.
      hint.textContent = collected===0
        ? 'Collect a stamp with every ' + best.unit + '. Each one pays out Crumbs.'
        : '';
      hint.style.display = collected===0 ? 'block' : 'none';
    }
    hubEl('missionStamps').innerHTML=best.steps.map(function(x,i){
      return '<i class="'+(x.done?'on':(i===best.next?'next':''))+'"></i>';
    }).join('');
    strip.style.display='flex';
    if(!strip.dataset.bound){
      strip.dataset.bound='1';
      strip.addEventListener('click',function(){
        var t=club.querySelector('[data-tab="earn"]'); if(t) t.click();
      });
    }
  }

  // WHERE THE CRUMBS CAME FROM.
  // Grouped by rule name, not by the merchant-editable title, for the same reason the icons
  // are. Only approved, positive rows count: pending Crumbs aren't earned yet, and folding
  // redemptions in would make a chart that answers two questions at once and neither clearly.
  var SRC_GROUPS=[
    {key:'orders',   label:'Orders',        colour:'#E8622A', rules:['$purchase']},
    {key:'referral', label:'Referrals',     colour:'#4A2D8F', rules:['$referral','$referral_complete']},
    {key:'reviews',  label:'Reviews',       colour:'#2f7d43', rules:['$review','$product_review']},
    {key:'birthday', label:'Birthday',      colour:'#D9A83C', rules:['$birthday']},
    {key:'social',   label:'Follows & signups', colour:'#8265CE',
      rules:['$signup','$newsletter_signup','$instagram_follow','$facebook_like','$tiktok_follow','$twitter_follow']},
    {key:'other',    label:'Bonuses',       colour:'#5b544c', rules:[]}
  ];
  function paintSources(){
    var host=hubEl('src'); if(!host || !hubRows) return;
    var by={}, total=0;
    hubRows.forEach(function(r){
      if(r.state!=='approved' || r.points<=0) return;
      // The starting grant is not a source of Crumbs — nobody earned it by doing anything, and
      // at 2,000 points it would swamp the ring and answer "where do your Crumbs come from?"
      // with something the member cannot repeat.
      if(r.kind==='grant') return;
      var g=null;
      for(var i=0;i<SRC_GROUPS.length;i++) if(SRC_GROUPS[i].rules.indexOf(r.ruleName)>=0){ g=SRC_GROUPS[i]; break; }
      if(!g) g=SRC_GROUPS[SRC_GROUPS.length-1];             // anything unmapped is a bonus
      if(!by[g.key]) by[g.key]={g:g,pts:0,n:0};
      by[g.key].pts+=r.points; by[g.key].n++; total+=r.points;
    });
    var rows=Object.keys(by).map(function(k){return by[k];}).sort(function(a,b){return b.pts-a.pts;});
    // One source is a circle, not a chart. Below two the table alone tells the story.
    if(!rows.length || total<=0 || rows.length<2){ host.style.display='none'; return; }

    // Donut geometry. r=44 in a 120 box with a 16 stroke leaves 4px of breathing room; the
    // circumference is what every dash length is a fraction of.
    var R=44, C=2*Math.PI*R, off=0;
    var svg=hubEl('srcSvg');
    if(svg){
      svg.innerHTML='<circle cx="60" cy="60" r="'+R+'" fill="none" stroke="rgba(20,18,16,.06)" stroke-width="16"></circle>'
        + rows.map(function(x){
            var frac=x.pts/total, len=frac*C, dash=len+' '+(C-len), o=-off;
            off+=len;
            // Starts fully offset and settles into place, so the ring draws itself once.
            return '<circle class="hsrc__seg" cx="60" cy="60" r="'+R+'" fill="none" stroke="'+x.g.colour
              +'" stroke-width="16" stroke-dasharray="'+dash+'" stroke-dashoffset="'+(reduce?o:o+C)
              +'" data-final="'+o+'"></circle>';
          }).join('');
      if(!reduce) requestAnimationFrame(function(){
        svg.querySelectorAll('.hsrc__seg').forEach(function(s){ s.setAttribute('stroke-dashoffset', s.dataset.final); });
      });
    }
    var tot=hubEl('srcTotal'); if(tot) tot.textContent=total.toLocaleString();
    var lbl=hubEl('srcLabel');
    // Name the biggest source in the middle of the ring: the single most useful sentence the
    // chart can produce is "most of your Crumbs come from X".
    if(lbl) lbl.innerHTML='Crumbs earned';
    var tb=hubEl('srcRows');
    if(tb) tb.innerHTML=rows.map(function(x){
      return '<tr><td><span class="hsrc__cat"><span class="hsrc__dot" style="background:'+x.g.colour+'"></span>'
        +x.g.label+'</span></td><td class="hsrc__n">'+x.n+'</td>'
        +'<td class="hsrc__pts">'+x.pts.toLocaleString()+'</td></tr>';
    }).join('');
    host.style.display='grid';
    if(block) block.style.display='block';
  }

  function paintLedger(keepScroll){
    var list=hubEl('ledger'); if(!list || !hubRows) return;
    var rows=hubRows.filter(function(r){
      if(hubFilter==='all') return true;
      // Orders were never a peer of Rewards or Tiers — they're one kind of line on the
      // statement, so they're a filter here rather than a tab of their own.
      if(hubFilter==='orders') return r.ruleName==='$purchase';
      return hubFilter==='in' ? r.points>0 : r.points<0;
    });
    var count=hubEl('ledgerCount'); if(count) count.textContent=hubRows.length?'('+hubRows.length+')':'';
    if(!rows.length){
      list.innerHTML='<li class="hub__empty"><span class="hub__empty__i">🍰</span>'
        +'<div class="hub__empty__t">'+(hubFilter==='out'?'Nothing spent yet':hubFilter==='orders'?'No orders yet':'Nothing here yet')+'</div>'
        +'<p class="hub__empty__d">'+(hubFilter==='out'
            ? 'Once you redeem a reward it&rsquo;ll show up here.'
            : hubFilter==='orders'
            ? 'Orders you place from now on will appear here with the Crumbs they earned.'
            : 'Your next order will be the first line on your timeline.')+'</p>'
        +'<a class="btn btn--primary" href="/collections">Start an order</a></li>';
      var mb0=hubEl('ledgerMore'); if(mb0) mb0.style.display='none';
      return;
    }
    // Six rows on a phone is about one thumb-length of scrolling; ten on desktop fills the
    // panel without dwarfing the sections below it.
    var page = innerWidth<900 ? 6 : 10;
    var limit = hubShown || page;
    var slice = rows.slice(0, limit);
    var top = keepScroll ? list.getBoundingClientRect().top : null;
    list.innerHTML = slice.map(function(r){
      var cls='lrow lrow--'+(r.points<0?'out':'in')+(r.state!=='approved'?' lrow--'+r.state:'');
      // The documented state enum is pending | declined | approved | void | expired.
      // approved carries no chip on purpose: it is the default, and a badge on every second
      // row is noise that hides the exceptions.
      var chip = r.state==='pending' ? '<span class="hub__chip hub__chip--pending">Pending</span>'
               : r.state==='void' ? '<span class="hub__chip hub__chip--void">Refunded</span>'
               : r.state==='expired' ? '<span class="hub__chip hub__chip--void">Expired</span>'
               : r.state==='declined' ? '<span class="hub__chip hub__chip--declined">Declined</span>' : '';
      var bal = (r.state==='approved' && r.bal!=null)
        ? '<span class="lrow__bal">balance '+r.bal.toLocaleString()+'</span>' : '';
      var meta=[hubDate(r.ts), r.ref].filter(Boolean).join(' &middot; ');
      return '<li class="'+cls+'">'
        +'<span class="lrow__icon" aria-hidden="true">'+r.icon+'</span>'
        +'<div class="lrow__body"><div class="lrow__t">'+r.title+'</div>'
        +'<div class="lrow__m">'+meta+chip+'</div></div>'
        +'<div class="lrow__amt">'+(r.points>0?'+':'')+r.points.toLocaleString()+bal+'</div></li>';
    }).join('');
    if(top!=null){
      // "Show more" must not throw the member back up the page: hold the list's position.
      var now=list.getBoundingClientRect().top;
      if(now!==top) scrollBy(0, now-top);
    }
    var mb=hubEl('ledgerMore');
    if(mb){
      if(rows.length>limit){ mb.style.display='block'; mb.textContent='Show more ('+(rows.length-limit)+')'; }
      else mb.style.display='none';
    }
  }

  // ---- THE STATEMENT STARTS WHERE THE MEMBER DOES --------------------------------------
  // Crumbs granted by hand — the tier-recognition top-ups given to customers who were already
  // ordering before Elevete Fam existed, plus any support goodwill — arrived as separate rows
  // reading "Crumbs added", with no reason attached. On a real account that was three of six
  // lines: +1,000, +500 and +500, all unexplained. A statement whose loudest entries cannot be
  // accounted for makes the whole programme look arbitrary, and there is nothing the member
  // can do with the information.
  //
  // They fold into one opening line instead: "Crumbs to get you started". Anything dated on or
  // before the member's enrolment folds in too, which is the "start from the join date" part —
  // for anyone who joined after the grants were issued that empties the top of the ledger
  // completely.
  //
  // NOT hidden — folded. The row keeps the full sum, sits at the oldest grant's date, and the
  // running balance therefore still reconciles to the figure on the membership card. Hiding
  // credited points outright would leave a statement that visibly does not add up, which costs
  // more trust than the untidy rows ever did.
  // Only positive manual credits fold. A negative adjustment is money taken back off someone
  // and stays on its own line where they can see it.
  function foldGrants(rows){
    if(!Object.prototype.hasOwnProperty.call(rows,'length')) return rows;
    var joinTs=null;
    try{
      var c=window.loyaltylion && window.loyaltylion.customer;
      var e=c && (c.enrolledAt || c.enrolled_at || c.createdAt || c.created_at);
      if(e){ var d=new Date(e); if(!isNaN(d.getTime())) joinTs=d.getTime(); }
    }catch(err){}

    var kept=[], folded=[];
    rows.forEach(function(r){
      var manualCredit = (r.kind==='add' || r.kind==='adjustment') && r.points>0 && !r.ruleName;
      var preJoin = joinTs!=null && r.ts && r.ts.getTime() < joinTs && r.points>0;
      (manualCredit || preJoin ? folded : kept).push(r);
    });
    if(folded.length===0) return rows;

    var sum=0, oldest=null, anyPending=false;
    folded.forEach(function(r){
      sum+=r.points;
      if(r.state!=='approved') anyPending=true;
      if(!oldest || (r.ts && oldest.ts && r.ts<oldest.ts) || (!oldest.ts && r.ts)) oldest=r;
    });
    kept.push({
      ts: oldest ? oldest.ts : null, points: sum, state: anyPending?'pending':'approved',
      kind: 'grant', ruleName: '', icon: '✨',
      title: 'Crumbs to get you started', note: '', ref: ''
    });
    // Re-sort: the fold sits at the oldest grant's date, which is normally the bottom.
    kept.sort(function(a,b){ return (b.ts?b.ts.getTime():0)-(a.ts?a.ts.getTime():0); });
    return kept;
  }

  // Balances are attached AFTER filtering decisions, on the full list, so the running total is
  // the member's real balance history and not an artefact of whichever pill is active.
  // Pending rows are skipped on purpose: they haven't moved the balance, so giving them a
  // running total would make the column stop adding up.
  function attachBalances(rows){
    var run=hubBalance;
    rows.forEach(function(r){
      if(r.state!=='approved') return;
      r.bal=run; run-=r.points;
    });
  }

  function hubCard(c, pts, ci, spend){
    var t=TIERS[ci]||TIERS[0];
    var tm=c.loyaltyTierMembership||c.loyalty_tier_membership||{};
    var card=hubEl('mcard');
    if(card) card.dataset.tier=ci;
    var tn=hubEl('mcardTier'); if(tn) tn.textContent=t.name;
    var rt=hubEl('mcardRate'); if(rt) rt.textContent=t.rate+'× per RM1';
    // The worth line is computed once in render() against the live catalogue and handed over
    // here. Two different answers to "what is my balance worth" on one page is the kind of
    // thing that gets screenshotted and sent to support.
    var w=hubEl('mcardWorth');
    if(w){
      if(hubWorthHTML){ w.innerHTML=hubWorthHTML; w.style.display='block'; }
      else w.style.display='none';
    }
    // Joined date, if LoyaltyLion carries one. Shown as a card would print it.
    // Cardholder. First name plus a surname initial, the way a card is actually printed —
    // and never the full surname, which on a shared screen is more than the member asked for.
    var nm=hubEl('mcardName');
    if(nm){
      var fn=(c.firstName||c.first_name||'').trim(), ln=(c.lastName||c.last_name||'').trim();
      var printed=(fn+(ln?' '+ln.charAt(0)+'.':'')).trim();
      if(printed) nm.textContent=printed; else nm.innerHTML='&nbsp;';
    }
    var since=hubEl('mcardSince');
    if(since){
      var j=c.enrolledAt||c.enrolled_at||c.createdAt||c.created_at||c.joinedAt||null;
      var d=j?new Date(j):null;
      if(d && !isNaN(d.getTime())) since.textContent='Member since '+d.toLocaleDateString('en-MY',{month:'short',year:'numeric'});
      else since.innerHTML='&nbsp;';
    }
    // NEXT-TIER PANEL. Progress is measured inside the CURRENT band, not across the whole
    // ladder: "62% of the way to Indulgent" is a fact the member can act on, where "31% of
    // the way through the programme" is not.
    var lab=hubEl('nextLabel'), txt=hubEl('nextText'), fill=hubEl('nextFill'),
        from=hubEl('nextFrom'), to=hubEl('nextTo'), perk=hubEl('nextPerk'),
        lad=hubEl('ladder'), pk=hubEl('perks');
    var min=t.min||0, max=t.max||null;

    // The ladder. Rendered for every tier including the top one, where it's the reward.
    if(lad){
      lad.innerHTML=TIERS.map(function(x,i){
        var cls = i===ci ? 'is-cur' : (i<ci ? 'is-done' : '');
        return '<span class="'+cls+'">'+x.name+'</span>';
      }).join('');
    }

    // What each tier actually unlocks, in the member's language. Taken from the same benefit
    // matrix further down the page, so the hero can't promise something the table denies.
    var PERKS={
      1:[['7 Crumbs per RM1','instead of 5'],['RM10 birthday treat','up from RM5'],['Preview new flavours','before anyone else']],
      2:[['10 Crumbs per RM1','our best rate'],['RM15 birthday treat','the biggest one'],['First dibs on limited editions','before they sell out']]
    };
    function paintPerks(list, open){
      if(!pk) return;
      pk.innerHTML=(list||[]).map(function(p){
        return '<li class="'+(open?'is-open':'')+'"><span><b>'+p[0]+'</b> &mdash; '+p[1]+'</span></li>';
      }).join('');
    }

    if(ci<TIERS.length-1 && max){
      var nx=TIERS[ci+1], gap=Math.max(0,max-spend);
      var pct=Math.max(3,Math.min(100,Math.round((spend-min)/(max-min)*100)));
      if(lab) lab.textContent='Next tier';
      // PROGRESS FIRST, DISTANCE SECOND. "RM179 to go" is a bill; "you're 78% of the way" is
      // an achievement with a bill attached. Same fact, and the endowed-progress framing is
      // the one that gets finished. Below 10% we lead with the destination instead, because
      // "you're 4% of the way" is a discouraging number to open on.
      if(txt) txt.innerHTML = gap<=0
        ? 'You&rsquo;ve qualified for <b>'+nx.name+'</b> &mdash; it lands on your next order.'
        : (pct>=10
            ? 'You&rsquo;re <b>'+pct+'% of the way</b> to '+nx.name+' &mdash; RM'+gap.toLocaleString()+' of spend to go.'
            : 'Next stop <b>'+nx.name+'</b> &mdash; RM'+gap.toLocaleString()+' of spend away.');
      if(from) from.textContent=t.name;
      if(to) to.textContent=nx.name+' · RM'+max.toLocaleString();
      if(perk) perk.innerHTML='';
      paintPerks(PERKS[ci+1], false);
      // Painted on the next frame so the bar animates from 0 rather than snapping — the one
      // piece of motion in the hub, and it's showing progress, which is what motion is for.
      if(fill){ var sc='scaleX('+(pct/100)+')';
        if(reduce) fill.style.transform=sc; else requestAnimationFrame(function(){ fill.style.transform=sc; }); }
    } else {
      // TOP TIER IS NOT A DEAD END. These are the best customers on the file and the old panel
      // told them there was nothing left to do. Now it hands back what they hold: every perk
      // unlocked, in colour, with the ticks the lower tiers can only see greyed out.
      if(lab) lab.textContent='Top tier';
      // NOT 'permanently'. The live payload carries loyaltyTierMembership.expiresAt (a year out
      // for this member) and loyaltyTierEligibilityValidUntil — tiers re-qualify annually. Saying
      // permanent was simply false, and the true version is the better retention line anyway:
      // a date to hold on to beats a status with nothing left to do.
      var untilRaw = tm && (tm.expiresAt || tm.expires_at);
      var until = untilRaw ? new Date(untilRaw) : null;
      if(txt) txt.innerHTML = (until && !isNaN(until.getTime()))
        ? '<b>'+t.name+'</b> until <b>'+until.toLocaleDateString('en-MY',{month:'long',year:'numeric'})
          +'</b> &mdash; keep ordering to hold it.'
        : '<b>'+t.name+'</b> &mdash; the highest tier we have.';
      if(from) from.textContent=t.name;
      if(to) to.textContent='Top of the ladder';
      if(perk) perk.innerHTML='';
      paintPerks(PERKS[TIERS.length-1], true);
      if(fill) fill.style.transform='scaleX(1)';
    }
    // Same percentiles as the tier matrix further down the page (real distribution of 78,652
    // buyers, pulled 23 Jul), so the two can never disagree.
    var rank=hubEl('nextRank');
    if(rank){
      rank.innerHTML = ci===2 ? '🏆 You&rsquo;re in the top <b>4%</b> of Elevete Fam members.'
                     : ci===1 ? 'You&rsquo;re in the top <b>22%</b> of Elevete Fam members.'
                     : 'Reach Indulgent and you&rsquo;d be in the top <b>22%</b> of members.';
      rank.style.display='block';
    }
  }

  function hubStats(c, pts, ci, spend){
    hubBalance=pts;
    var b=hubEl('balance'); if(b) b.textContent=pts.toLocaleString();
    try{ hubCard(c, pts, ci, spend); }catch(e){ if(window.console) console.warn('[sweet-club] card render failed:',e); }
    try{ paintRewards(c); }catch(e){ if(window.console) console.warn('[sweet-club] rewards tab failed:',e); }
    try{ paintChallenges(c); }catch(e){ if(window.console) console.warn('[sweet-club] challenges failed:',e); }
    // Every figure below is shown only when LoyaltyLion actually supplies it. A loyalty
    // statement that invents a number is worse than one that omits it.
    var pend = c.pointsPending!=null?c.pointsPending:(c.points_pending!=null?c.points_pending:null);
    var pt=hubEl('pendingTile');
    if(pt){
      if(pend>0){ hubEl('pending').textContent=(+pend).toLocaleString(); pt.style.display='flex'; }
      else pt.style.display='none';
    }
    var spent = c.pointsSpent!=null?c.pointsSpent:(c.points_spent!=null?c.points_spent:null);
    // There is no pointsEarned on the SDK customer — confirmed against a live session. The
    // lifetime figure is pointsLifetime (pointsTotal on older payloads); the ledger sum is the
    // last resort, and it only sees the pages of history we managed to load.
    var earned= c.pointsLifetime!=null?c.pointsLifetime
              :(c.pointsTotal!=null?c.pointsTotal
              :(c.pointsEarned!=null?c.pointsEarned:null));
    // Derive from the ledger when the SDK doesn't carry the totals — same data, our sum.
    if((spent==null||earned==null) && hubRows){
      var i=0,o=0;
      hubRows.forEach(function(r){ if(r.state!=='approved') return; if(r.points>0) i+=r.points; else o-=r.points; });
      if(earned==null) earned=i;
      if(spent==null) spent=o;
    }
    var et=hubEl('earnedTile');
    if(et){
      if(earned>0){ hubEl('earned').textContent=(+earned).toLocaleString(); et.style.display='flex'; }
      else et.style.display='none';
    }
    var stl=hubEl('spentTile');
    if(stl){
      if(spent>0){
        hubEl('spent').textContent=(+spent).toLocaleString();
        // 100 Crumbs = RM1, the rate stated at the top of the redeem section. Saying what the
        // spend was worth in ringgit is the whole point of the tile: "12,000 Crumbs" means
        // nothing, "RM120 of treats, free" is the reason to keep going.
        var w=hubEl('spentWorth');
        if(w) w.textContent='RM'+Math.round(spent/100).toLocaleString()+' of treats, free';
        stl.style.display='flex';
      } else stl.style.display='none';
    }
  }

  // Polls for the history the mounted component is fetching. Bounded: ~20s, then we either
  // fall back to LoyaltyLion's own table (if it rendered something) or state plainly that the
  // timeline couldn't load — never an indefinite skeleton.
  function adoptHistory(c, pts, ci, spend){
    var t0=Date.now(), tries=0;
    (function poll(){
      tries++;
      var rows = historyFromStore() || historyFromDom();
      if(rows && rows.length){
        rows.sort(function(a,b){ return (b.ts?b.ts.getTime():0)-(a.ts?a.ts.getTime():0); });
        rows=foldGrants(rows);
        hubRows=rows;
        attachBalances(rows);
        hubStats(c, pts, ci, spend);
        try{ paintSources(); }catch(e){ if(window.console) console.warn('[sweet-club] sources chart failed:',e); }
        paintLedger();
        return;
      }
      if(Date.now()-t0 < 20000){ setTimeout(poll, 700); return; }
      // Give up on adapting. If LoyaltyLion's own table drew anything, show that.
      var src=hubEl('historySrc');
      var drew = src && src.textContent.replace(/\s/g,'').length>0;
      var list=hubEl('ledger');
      if(drew && src){
        src.classList.add('is-shown');
        if(list) list.innerHTML='';
        var note=hubEl('ledgerNote');
        if(note){ note.textContent='Showing your history as LoyaltyLion supplies it.'; note.style.display='block'; }
        if(window.console) console.warn('[sweet-club] history adapter found no rows; showing LoyaltyLion table');
      } else if(list){
        list.innerHTML='<li class="hub__empty"><span class="hub__empty__i">🍰</span>'
          +'<div class="hub__empty__t">Nothing here yet</div>'
          +'<p class="hub__empty__d">Your next order will be the first line on your timeline.</p>'
          +'<a class="btn btn--primary" href="/collections">Start an order</a></li>';
      }
      var mb=hubEl('ledgerMore'); if(mb) mb.style.display='none';
    })();
  }

  // ---- FLAVOUR PASSPORT: PAGES ---------------------------------------------------------
  // Liquid renders one .fppage per dessert format, each carrying its own counts. The chip row
  // is built here rather than in Liquid so it can never drift out of step with the pages that
  // actually rendered — a page whose collection is empty simply never appears, and its chip
  // never appears either.
  // With JS off every page stays visible and stacked: longer, but nothing is lost.
  function passportPages(){
    var wrap=club.querySelector('[data-hub="passport"]'); if(!wrap) return;
    var nav=wrap.querySelector('[data-fp="nav"]');
    var pages=[].slice.call(wrap.querySelectorAll('.fppage'));
    if(!nav || pages.length===0) return;
    if(nav.childElementCount) return;                       // already built

    var totTried=0, totAll=0;
    pages.forEach(function(p){ totTried+=+p.dataset.tried||0; totAll+=+p.dataset.total||0; });

    var elAll=wrap.querySelector('[data-fp="all"]'),
        elTitle=wrap.querySelector('[data-fp="title"]'),
        elSub=wrap.querySelector('[data-fp="sub"]'),
        elRing=wrap.querySelector('[data-fp="ring"]'),
        elPct=wrap.querySelector('[data-fp="pct"]');

    if(elAll) elAll.textContent='· '+totTried+'/'+totAll;

    // One chip per page. The count is the point of the chip, so it is never abbreviated away.
    pages.forEach(function(p,i){
      var tried=+p.dataset.tried||0, total=+p.dataset.total||0;
      var b=document.createElement('button');
      b.type='button'; b.className='fpchip'; b.setAttribute('role','tab');
      b.setAttribute('aria-selected', i===0 ? 'true' : 'false');
      b.dataset.fpTo=String(i);
      if(tried===0) b.className+=' is-empty';
      if(tried===total && total>0) b.className+=' is-full';
      b.innerHTML='<span>'+p.dataset.label+'</span><span class="fpchip__n">'+tried+'/'+total+'</span>';
      nav.appendChild(b);
    });

    function show(i){
      pages.forEach(function(p,j){ p.hidden = j!==i; });
      [].slice.call(nav.children).forEach(function(c,j){
        c.setAttribute('aria-selected', j===i ? 'true' : 'false');
      });
      var p=pages[i], tried=+p.dataset.tried||0, total=+p.dataset.total||0,
          left=+p.dataset.left||0, pct=+p.dataset.pct||0, label=(p.dataset.label||'').toLowerCase();
      // The headline and the ring describe the page you are looking at; the total beside the
      // eyebrow keeps the whole picture on screen at the same time.
      if(elTitle) elTitle.innerHTML='You&rsquo;ve tried <b>'+tried+'</b> of '+total+' '+label;
      if(elSub) elSub.textContent = left>0
        ? left+' still to stamp. Tap any faded one to meet it.'
        : 'This page is complete.';
      if(elRing) elRing.style.setProperty('--p', pct);
      if(elPct) elPct.innerHTML=pct+'<i>%</i>';
    }

    nav.addEventListener('click', function(e){
      var b=e.target.closest('.fpchip'); if(!b) return;
      show(+b.dataset.fpTo);
    });
    // Arrow keys, because the chips carry role="tab" and a keyboard user is entitled to expect it.
    nav.addEventListener('keydown', function(e){
      if(e.key!=='ArrowRight' && e.key!=='ArrowLeft') return;
      var cs=[].slice.call(nav.children), cur=cs.indexOf(document.activeElement);
      if(cur<0) return;
      e.preventDefault();
      var nxt=(cur + (e.key==='ArrowRight'?1:-1) + cs.length) % cs.length;
      cs[nxt].focus(); show(nxt);
    });
    show(0);
  }

  // ---- STAGING PREVIEW MODE -----------------------------------------------------------
  // Everything in this hub is data-gated: no LoyaltyLion history, no donut, no ledger. That
  // makes the design impossible to review until the data path is confirmed, and confirming it
  // needs a logged-in member. `?rc_demo=1` paints the whole hub from representative sample
  // rows so the layout can be judged on its own.
  // Guarded three ways: it needs an explicit query string a customer would never type, it
  // never touches LoyaltyLion, and it stamps a visible banner so no figure on screen can be
  // mistaken for a real balance. REMOVE THIS BLOCK BEFORE ANY LIVE PUSH.
  function hubDemo(){
    var now=Date.now(), d=function(days){ return new Date(now-days*86400000).toISOString(); };
    var rows=[
      {resource:'activity',created_at:d(2),points_pending:540,activity:{state:'pending',value:540,rule:{name:'$purchase',title:'Make a purchase'},order:{merchant_number:'142349'}}},
      {resource:'activity',created_at:d(3),points_approved:250,activity:{state:'approved',value:250,rule:{name:'$review',title:'Leave a review'}}},
      {resource:'claimed_reward',created_at:d(9),claimed_reward:{point_cost:1000,state:'approved',reward:{title:'Free Black Forest Cake Slice'}}},
      {resource:'activity',created_at:d(14),points_approved:1000,activity:{state:'approved',value:1000,rule:{name:'$referral',title:'Refer a friend'}}},
      {resource:'activity',created_at:d(21),points_approved:740,activity:{state:'approved',value:740,rule:{name:'$purchase',title:'Make a purchase'},order:{merchant_number:'141002'}}},
      {resource:'adjustment',created_at:d(28),points_approved:500,adjustment:{note:'Goodwill from support'}},
      {resource:'activity',created_at:d(34),points_approved:500,activity:{state:'approved',value:500,rule:{name:'$birthday',title:'Happy Birthday'}}},
      {resource:'activity',created_at:d(40),points_approved:150,activity:{state:'approved',value:150,rule:{name:'$newsletter_signup',title:'Sign up to our mailing list'}}},
      {resource:'activity',created_at:d(41),points_approved:250,activity:{state:'approved',value:250,rule:{name:'$signup',title:'Join our program'}}},
      {resource:'activity',created_at:d(55),points_approved:920,activity:{state:'approved',value:920,rule:{name:'$purchase',title:'Make a purchase'},order:{merchant_number:'139884'}}}
    ];
    var fake={
      firstName:'Syafiq', lastName:'Lee', enrolled:true, enrolledAt:d(41),
      pointsApproved:3310, pointsRedeemable:3310, pointsPending:540, pointsSpent:1000,
      loyaltyTierEligibleSpend:42100,                      // minor units — RM421, i.e. Indulgent
      loyaltyTierMembership:{loyaltyTier:{id:28163,name:'Indulgent'}},
      completedRules:[{ruleId:247464},{ruleId:247982},{ruleId:248429}],
      challenges:[
        {title:'Becoming a regular', kind:'order', counter:3, milestones:[
          {target:2, reward:500, name:'Second helping', state:'complete'},
          {target:3, reward:750, name:'Officially a regular', state:'complete'},
          {target:5, reward:1200, name:'The usual', state:'locked'},
          {target:8, reward:2000, name:'House favourite', state:'locked'}]},
        {title:'Bring a friend', kind:'referral', counter:1, milestones:[
          {target:1, reward:500, name:'First friend', state:'complete'},
          {target:2, reward:750, name:'Word gets around', state:'locked'},
          {target:3, reward:1000, name:'Chief cake enabler', state:'locked'},
          {target:5, reward:2000, name:'Cake club founder', state:'locked'}]}
      ],
      claimedRewards:[
        {id:1,state:'available',point_cost:1000,claimed_at:d(9),expires_at:d(-21),
         reward:{title:'Free Black Forest Cake Slice'},redeemable:{code:'CRUMBS-8F2K4Q'}},
        {id:2,state:'available',point_cost:500,claimed_at:d(4),expires_at:d(-9),
         reward:{title:'MYR 5 off your order'},redeemable:{code:'CRUMBS-2XR7PM'}},
        {id:3,state:'used',point_cost:1000,claimed_at:d(64),reward:{title:'Free Tokeru Cheese Cake Slice'}},
        {id:4,state:'void',point_cost:500,claimed_at:d(96),reward:{title:'MYR 5 off your order'}}
      ],
      referralUrls:{direct:'https://prz.io/demo123'}
    };
    club.dataset.shopifyCustomer='1';
    var banner=document.createElement('div');
    banner.textContent='PREVIEW — sample data, not a real balance';
    banner.style.cssText='background:#141210;color:#FCD34D;font:700 11px/1.4 var(--body),sans-serif;'
      +'letter-spacing:.1em;text-transform:uppercase;text-align:center;padding:7px 10px;position:relative;z-index:9';
    club.insertBefore(banner, club.firstChild);
    // The passport and badges are inside a customer-only Liquid block, so a preview session (which
    // is a guest) has no scaffold for them. Build an empty one with representative counts so the
    // whole tab can be reviewed; the real page renders these server-side from order history.
    // Guard on the PASSPORT, not on a badges block that no longer exists — that stale check
    // meant a logged-in member opening ?rc_demo=1 got the fake 13-flavour passport injected
    // ABOVE their real one, two passports disagreeing on the same screen.
    var tiersPanel=club.querySelector('[data-panel="tiers"]');
    if(tiersPanel && !club.querySelector('[data-hub="passport"]')){
      tiersPanel.insertAdjacentHTML('afterbegin',
        '<section class="fpwrap" data-hub="passport" data-orders="12">'
        +'<div class="fphead"><div class="fphead__x">'
        +'<span class="hnext__l">Flavour passport <b data-fp="all"></b></span>'
        +'<div class="fphead__t" data-fp="title"></div>'
        +'<p class="fphead__d" data-fp="sub"></p></div>'
        +'<div class="fpring" data-fp="ring" style="--p:0" aria-hidden="true">'
        +'<span class="fpring__n" data-fp="pct">0<i>%</i></span></div></div>'
        +'<div class="fpnav" data-fp="nav" role="tablist" aria-label="Passport pages"></div>'
        +'<div class="fppages" data-fp="pages">'
        // Only the cakes page carries sample stamps; the other three sit at zero, which is
        // exactly what a cake-only member sees and the thing worth reviewing.
        +'<div class="fppage" data-fp-page="0" data-label="Cakes" data-tried="5" data-total="13" data-pct="38" data-left="8">'
        +'<ul class="fpgrid" data-hub="demoFlavours"></ul></div>'
        +'<div class="fppage" data-fp-page="1" data-label="Desserts" data-tried="0" data-total="5" data-pct="0" data-left="5"><ul class="fpgrid"></ul></div>'
        +'<div class="fppage" data-fp-page="2" data-label="Macarons" data-tried="0" data-total="9" data-pct="0" data-left="9"><ul class="fpgrid"></ul></div>'
        +'<div class="fppage" data-fp-page="3" data-label="Bites" data-tried="0" data-total="5" data-pct="0" data-left="5"><ul class="fpgrid"></ul></div>'
        +'</div></section>'
);
    }
    hubRows=foldGrants(rows.map(fromApiRow).sort(function(a,b){ return (b.ts?b.ts:0)-(a.ts?a.ts:0); }));
    render(fake);                                          // render() calls hubRender -> hubRelocate
    // Photos are copied from the catalogue, which only reaches the Redeem panel during
    // hubRelocate() inside render() — so the fill has to come after it, not before.
      // borrow the catalogue photographs so the passport looks like the real thing
      var fg=club.querySelector('[data-hub="demoFlavours"]');
      if(fg) fg.innerHTML=[].slice.call(club.querySelectorAll('[data-panel="redeem"] .card')).slice(0,13)
        .map(function(cd,i){
          var im=cd.querySelector('img'), t=(cd.querySelector('.card__title')||{}).textContent||'Flavour';
          var on=i<5;
          var nm=t.replace(/ Cake Slice| Slice/g,'');
          return '<li class="fp'+(on?' is-tried':'')+'"><a class="fp__link" href="#"'
            +' aria-label="'+nm+' — '+(on?'tried':'not tried yet')+'"><span class="fp__img">'
            +(im?'<img src="'+im.getAttribute('src')+'" alt="" width="120" height="120">':'')
            +'<span class="fp__mark" aria-hidden="true">'+(on?'✓':'')+'</span></span>'
            +'<span class="fp__name">'+nm+'</span></a></li>';
        }).join('');                                          // the real renderer, real code path
    attachBalances(hubRows);
    try{ paintSources(); }catch(e){ if(window.console) console.warn(e); }
    paintLedger();
  }

  // ---- ONE CONCEPT, ONE PLACE ----------------------------------------------------------
  // Measured on the built page: a logged-in member scrolled 9,365px — 11 phone screens — and
  // met rewards twice (the My rewards tab, then a 1,830px catalogue), tiers twice (a tab, then
  // a 1,303px matrix) and earning twice. Two navigation models, tabs and long page sections,
  // covering the same subjects. That was the confusion, and no restyle fixes it.
  //
  // So the sections are MOVED into their tab, not copied. Moving keeps a single DOM node, so
  // every handler already bound to it survives (the goal picker and the ringgit flip are bound
  // to .s-treats itself; redeem, earn-tile and keyboard handlers are delegated on document),
  // and there is no second copy to drift out of sync.
  // Guests never reach this code and keep the full-length page, which is where that content
  // does its selling.
  var HUB_HOSTS=[
    {panel:'redeem', take:['.s-treats','.s-soon']},   // what you can get, then what's coming
    {panel:'earn',   take:['.s-earn','.s-msim']},     // how to earn, then what an order would earn
    {panel:'tiers',  take:['.s-tiers']}
  ];
  var hubMoved=false;
  function hubRelocate(){
    if(hubMoved) return; hubMoved=true;
    HUB_HOSTS.forEach(function(h){
      var host=club.querySelector('[data-panel="'+h.panel+'"]'); if(!host) return;
      h.take.forEach(function(sel){
        var sec=club.querySelector(':scope > '+sel); if(!sec) return;
        sec.classList.add('is-hosted');
        host.appendChild(sec);
      });
    });
  }

  var hubStarted=false;
  function hubRender(c, pts, ci, spend){
    try{ hubRelocate(); }catch(e){ if(window.console) console.warn('[sweet-club] relocate failed:',e); }
    // Server-rendered, so it is already in the DOM — but it is built here so demo mode, which
    // injects its passport during render(), gets its chips too. Guarded internally against
    // running twice.
    try{ passportPages(); }catch(e){ if(window.console) console.warn('[sweet-club] passport pages failed:',e); }
    hubStats(c, pts, ci, spend);
    if(hubStarted){ if(hubRows){ attachBalances(hubRows); paintLedger(); } return; }
    hubStarted=true;
    // The component only fetches once it's mounted, and it mounts on the SDK's own refresh
    // cycle — nudge it, in case our markup landed after the SDK had already swept the page.
    try{ if(window.loyaltylion && window.loyaltylion.ui && window.loyaltylion.ui.refresh) window.loyaltylion.ui.refresh(); }catch(e){}
    adoptHistory(c, pts, ci, spend);
  }

  function animate(){
    // count-up
    qa('[data-ll="points"],[data-ll="points2"]').forEach(function(el){
      var target=+el.dataset.target||0,s=null;
      function up(ts){if(!s)s=ts;var p=Math.min((ts-s)/900,1);el.textContent=Math.round(target*(1-Math.pow(1-p,3))).toLocaleString();if(p<1)requestAnimationFrame(up);}
      requestAnimationFrame(up);
    });
    // fill bars on view
    var fills=qa('.track__fill,.quest__fill,.nudge__fill');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var f=e.target;f.style.transition='width 1s cubic-bezier(.23,1,.32,1)';f.style.width=f.dataset.w||'0';io.unobserve(f);}});},{threshold:.4});
    fills.forEach(function(f){io.observe(f);});
  }

  // Reveal/visibility setup. MUST run for EVERYONE, not just members: the tier-matrix ticks
  // are hidden by CSS until .mx gets .in, so when this lived inside render() (member-only,
  // and skipped entirely under reduced-motion) every logged-out guest saw a comparison matrix
  // with no ticks at all — the perk ladder invisible to the exact audience it's meant to sell.
  function revealSetup(){
    var rev=qa('.card,.tile,.vcard,.soon,.step');
    var mx=q('.mx');
    function showAll(){ if(mx) mx.classList.add('in'); rev.forEach(function(el){ el.classList.add('in'); }); }
    if(reduce){ showAll(); return; }              // reduced motion: show immediately, no animation
    rev.forEach(function(el){el.classList.add('reveal');});
    var io2=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io2.unobserve(e.target);}});},{threshold:.12});
    rev.forEach(function(el){io2.observe(el);});
    if(mx){var io3=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io3.unobserve(e.target);}});},{threshold:.25});io3.observe(mx);}
    // SAFETY NET: content must never depend on an animation firing. If an observer never
    // fires (element taller than the viewport so the threshold is never met, background tab,
    // headless/bot render, a JS error elsewhere), force everything visible anyway.
    setTimeout(showAll,2500);
    // confetti on redeem tap
    document.addEventListener('click',function(ev){ if(ev.target.closest('.rc__go--ok,.btn--primary')) burst(); });
  }
  function burst(){ var c=document.getElementById('rc-confetti'); if(!c){c=document.createElement('canvas');c.id='rc-confetti';document.body.appendChild(c);}
    var x=c.getContext('2d');c.width=innerWidth;c.height=innerHeight;var cols=['#E8622A','#4A2D8F','#FCD34D','#fff'],p=[];
    for(var i=0;i<90;i++)p.push({x:innerWidth/2,y:innerHeight*0.38,vx:(Math.random()-0.5)*13,vy:Math.random()*-13-3,col:cols[i%4],s:Math.random()*6+4,r:Math.random()*6,vr:(Math.random()-0.5)*0.5});
    var s=null;function fr(ts){if(!s)s=ts;var e=ts-s;x.clearRect(0,0,c.width,c.height);p.forEach(function(o){o.vy+=0.42;o.x+=o.vx;o.y+=o.vy;o.r+=o.vr;x.save();x.translate(o.x,o.y);x.rotate(o.r);x.fillStyle=o.col;x.fillRect(-o.s/2,-o.s/2,o.s,o.s);x.restore();});if(e<1300)requestAnimationFrame(fr);else x.clearRect(0,0,c.width,c.height);}
    requestAnimationFrame(fr);
  }

  // --- Redemption ------------------------------------------------------------
  // The store's LoyaltyLion theme ships no CSS for the slide-in loyalty-panel that
  // data-lion-account-link used to open (it rendered as an ~8,800px unstyled block). It DOES
  // fully style the rewards-list + redeem-reward-modal, so we drive those instead:
  //  - a specific reward card opens the themed redeem modal directly (loyaltylion.ui);
  //  - the general "Redeem" buttons open our drawer, which holds a themed rewards-list.
  var redeemDrawer=document.getElementById('rc-redeem');
  // Both drawers start closed. aria-hidden alone leaves their buttons keyboard-reachable —
  // Lighthouse flagged exactly that (aria-hidden-focus). `inert` takes them out of the focus
  // order and the a11y tree without touching the slide transition.
  if(redeemDrawer) redeemDrawer.setAttribute('inert','');
  function openRedeemDrawer(){
    if(!redeemDrawer) return;
    redeemDrawer.classList.add('is-open'); redeemDrawer.setAttribute('aria-hidden','false'); redeemDrawer.removeAttribute('inert');
    document.documentElement.style.overflow='hidden';
  }
  function closeRedeemDrawer(){
    if(!redeemDrawer) return;
    redeemDrawer.classList.remove('is-open'); redeemDrawer.setAttribute('aria-hidden','true'); redeemDrawer.setAttribute('inert','');
    document.documentElement.style.overflow='';
  }
  // LoyaltyLion's confirm modal prints "RM50 minimum spend" for vouchers only: it reads
  // reward.minimum_spend, which is 0 on product rewards. The cake slices hold the same RM50 rule
  // in minimum_requirements.cost, so their modal never mentions it. Add the line ourselves with
  // LoyaltyLion's own class, which brings the same info icon and styling from their stylesheet.
  // Amount comes from the SDK state, so a change in the LoyaltyLion admin carries through.
  function addMinSpendLine(rid){
    var rw=null;
    try{ rw=(window.loyaltylion.ui.store.getState().program.rewards||[]).filter(function(r){ return r.id===rid; })[0]; }catch(e){}
    var req=rw && rw.kind==='product_cart' && rw.minimum_requirements;
    if(!req || req.type!=='cost' || !(req.cost>0)) return;
    var tries=0;
    (function paint(){
      var btns=document.querySelector('.lion-redeem-reward-modal__button-container');
      if(!btns){ if(++tries<40) setTimeout(paint,100); return; }
      var box=btns.parentNode;
      if(box.querySelector('.lion-redeem-reward-modal__minimum-spend') || /minimum spend/i.test(box.textContent)) return;
      var line=document.createElement('div');
      line.className='lion-redeem-reward-modal__minimum-spend';
      line.textContent='RM'+req.cost+' minimum spend';
      box.insertBefore(line,btns);
    })();
  }
  function redeem(rid){
    var ui=window.loyaltylion && window.loyaltylion.ui;
    // Preferred: open the themed confirm modal for this exact reward. It only fires once rewards
    // are in the SDK's state — the drawer's rewards-list (mounted at start) guarantees that — so
    // if the modal hasn't appeared shortly, fall back to the drawer list.
    if(rid && ui && typeof ui.openRedeemRewardModal==='function'){
      try{ ui.openRedeemRewardModal(+rid); }catch(e){}
      addMinSpendLine(+rid);
      // Checked twice, not once. LoyaltyLion's modal can take longer than 500ms to mount on a
      // cold SDK, and a single early check opened our drawer on top of a modal that was about
      // to appear — which is exactly the "why is it a drawer?" report.
      setTimeout(function(){
        if(document.querySelector('.lion-modal')) return;
        setTimeout(function(){ if(!document.querySelector('.lion-modal')) openRedeemDrawer(); },700);
      },500);
      return;
    }
    openRedeemDrawer();
  }
  if(redeemDrawer){
    redeemDrawer.addEventListener('click',function(ev){ if(ev.target.closest('[data-redeem-close]')) closeRedeemDrawer(); });
  }
  document.addEventListener('keydown',function(ev){
    if(ev.key==='Escape' && redeemDrawer && redeemDrawer.classList.contains('is-open')) closeRedeemDrawer();
  });
  document.addEventListener('click',function(ev){
    var trig=ev.target.closest('[data-redeem]');
    if(trig){ ev.preventDefault(); openRedeemDrawer(); return; }
    var go=ev.target.closest('.rc__go--ok');
    if(go){ var cd=go.closest('.card,.vcard'); redeem(cd && cd.dataset.rid); }
  });

  // --- Earning ---------------------------------------------------------------
  // Mirror of redemption. An actionable earn tile opens LoyaltyLion's themed action widget via
  // ui.openRuleActionModal(ruleId) — the only thing that actually credits the action. The earn
  // drawer holds a mounted rules-list which (a) loads the rules into SDK state so the modal works,
  // and (b) is the fallback surface if the modal can't open.
  var earnDrawer=document.getElementById('rc-earn-drawer');
  if(earnDrawer) earnDrawer.setAttribute('inert','');
  function openEarnDrawer(){ if(!earnDrawer) return; earnDrawer.classList.add('is-open'); earnDrawer.setAttribute('aria-hidden','false'); earnDrawer.removeAttribute('inert'); document.documentElement.style.overflow='hidden'; }
  function closeEarnDrawer(){ if(!earnDrawer) return; earnDrawer.classList.remove('is-open'); earnDrawer.setAttribute('aria-hidden','true'); earnDrawer.setAttribute('inert',''); document.documentElement.style.overflow=''; }
  function earn(rid){
    var ui=window.loyaltylion && window.loyaltylion.ui;
    if(rid && ui && typeof ui.openRuleActionModal==='function'){
      try{ ui.openRuleActionModal(+rid); }catch(e){}
      setTimeout(function(){ if(!document.querySelector('.lion-modal')) openEarnDrawer(); },500);
      return;
    }
    openEarnDrawer();
  }
  if(earnDrawer){ earnDrawer.addEventListener('click',function(ev){ if(ev.target.closest('[data-earn-close]')) closeEarnDrawer(); }); }
  document.addEventListener('keydown',function(ev){ if(ev.key==='Escape' && earnDrawer && earnDrawer.classList.contains('is-open')) closeEarnDrawer(); });
  function tileAction(tile){
    if(tile.hasAttribute('data-bday-open')) return;   // birthday tile: handled by rcBday's sheet
    if(tile.dataset.earnUrl){ window.open(tile.dataset.earnUrl,'_blank','noopener'); return; }
    earn(tile.dataset.rid);
  }
  document.addEventListener('click',function(ev){
    var tile=ev.target.closest('.tile.is-claimable');
    if(tile){ tileAction(tile); }
  });
  document.addEventListener('keydown',function(ev){
    if(ev.key!=='Enter' && ev.key!==' ') return;
    var tile=ev.target.closest && ev.target.closest('.tile.is-claimable');
    if(tile){ ev.preventDefault(); tileAction(tile); }
  });

  // --- Birthday (28 Oct 2026) -----------------------------------------------------
  // LoyaltyLion is the only home for birthdays: it issues the voucher on the day and pushes
  // `birthday` to Klaviyo by itself. The member saves it here through the SDK's own
  // api.customers.setBirthday, which writes state.customer.birthday into the SDK store, so
  // store.subscribe repaints the tile and prompt instantly. LoyaltyLion accepts a birthday once.
  // Fallback if that internal API ever disappears: LoyaltyLion's own birthday modal (rule 247986).
  window.rcBday=(function(){
    var AMT=[5,10,15], tier=0, sheet=document.getElementById('rc-bday'), lastBd;
    var MON=['January','February','March','April','May','June','July','August','September','October','November','December'];
    function ll(){ return window.loyaltylion||{}; }
    function store(){ var u=ll().ui; return u&&u.store&&typeof u.store.getState==='function'?u.store:null; }
    function cust(){ var st=store(); return st?(st.getState().customer||null):null; }
    function bday(){ var c=cust()||ll().customer||{}; return c.birthday||null; }
    function parts(iso){ var m=/^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso||'')); return m?{y:+m[1],m:+m[2],d:+m[3]}:null; }
    function short(p){ return p.d+' '+MON[p.m-1].slice(0,3); }
    function amt(){ return 'RM'+AMT[tier]+' birthday voucher'; }
    function paint(){
      var bd=parts(bday()), member=!!cust()||!!ll().customer;
      var tile=club.querySelector('.tile[data-kind="birthday"]'), st=tile&&tile.querySelector('.tile__state');
      if(st){
        if(bd){ st.textContent='✓ Saved: '+short(bd); st.className='tile__state only-member tile__state--done';
          tile.classList.add('is-done'); tile.classList.remove('is-claimable'); tile.removeAttribute('role'); tile.removeAttribute('tabindex'); tile.removeAttribute('data-bday-open'); }
        else { st.textContent='Add your birthday →'; st.className='tile__state only-member tile__state--claim';
          tile.classList.add('is-claimable'); tile.setAttribute('role','button'); tile.setAttribute('tabindex','0'); tile.setAttribute('data-bday-open','');
          tile.setAttribute('aria-label','Happy Birthday: add your birthday to get your '+amt()); }
      }
      var cta=club.querySelector('[data-bday-cta]');
      if(cta && member){
        cta.hidden=false; cta.classList.toggle('is-saved',!!bd);
        var t=cta.querySelector('[data-bday-cta-title]'), d=cta.querySelector('[data-bday-cta-desc]');
        if(bd){ t.textContent='Birthday saved: '+short(bd); d.textContent='Your '+amt()+' lands in your account that morning.'; }
        else { t.textContent='Get a RM'+AMT[tier]+' birthday voucher'; d.innerHTML='Add your birthday and we&rsquo;ll put it in your account on the day. You can only set it once.'; }
      }
      club.querySelectorAll('[data-bday-amt]').forEach(function(e){ e.textContent=amt(); });
    }
    function step(name){ sheet.querySelectorAll('[data-bday-step]').forEach(function(e){ e.hidden=e.dataset.bdayStep!==name; }); }
    var input=sheet&&sheet.querySelector('#rc-bday-date'), go=sheet&&sheet.querySelector('[data-bday-step="pick"] .rc-bday__go');
    function today(){ var n=new Date(); return n.getFullYear()+'-'+String(n.getMonth()+1).padStart(2,'0')+'-'+String(n.getDate()).padStart(2,'0'); }
    function valid(){ var p=parts(input&&input.value); return !!p && p.y>=1920 && input.value<=today(); }
    function open(){
      var api=ll().api&&ll().api.customers;
      if(!sheet || !api || typeof api.setBirthday!=='function'){ var u=ll().ui; if(u&&typeof u.openRuleActionModal==='function'){ try{u.openRuleActionModal(247986);}catch(e){} } return; }
      if(bday()) return;
      paint(); step('pick'); input.max=today(); go.disabled=!valid();
      sheet.querySelectorAll('[data-bday-err],[data-bday-err2]').forEach(function(e){ e.hidden=true; });
      sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden','false'); sheet.removeAttribute('inert');
      document.documentElement.style.overflow='hidden'; document.documentElement.classList.add('rc-bday-open'); setTimeout(function(){ input.focus(); },320);
    }
    function close(){ if(!sheet)return; sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden','true'); sheet.setAttribute('inert',''); document.documentElement.style.overflow=''; document.documentElement.classList.remove('rc-bday-open'); }
    if(sheet){
      sheet.setAttribute('inert','');
      input.addEventListener('input',function(){ go.disabled=!valid(); });
      sheet.querySelector('[data-bday-step="pick"]').addEventListener('submit',function(ev){
        ev.preventDefault(); if(!valid()) return;
        var p=parts(input.value), n=new Date();
        sheet.querySelector('[data-bday-pretty]').textContent=p.d+' '+MON[p.m-1]+' '+p.y;
        sheet.querySelector('[data-bday-today]').hidden=!(p.m===n.getMonth()+1 && p.d===n.getDate());
        step('confirm'); sheet.querySelector('[data-bday-save]').focus();
      });
      sheet.querySelector('[data-bday-edit]').addEventListener('click',function(){ step('pick'); input.focus(); });
      var saveBtn=sheet.querySelector('[data-bday-save]');
      saveBtn.addEventListener('click',function(){
        if(saveBtn.disabled) return; saveBtn.disabled=true; saveBtn.textContent='Saving…';
        var err=sheet.querySelector('[data-bday-err2]'); err.hidden=true;
        Promise.resolve(ll().api.customers.setBirthday({birthday:input.value,locale:'en'})).then(function(r){
          if(r && r.error) throw r.error;
          var p=parts(input.value);
          sheet.querySelector('[data-bday-done-msg]').textContent='Your '+amt()+' will land in your account on the morning of '+p.d+' '+MON[p.m-1]+'.';
          step('done'); sheet.querySelector('[data-bday-step="done"]').focus(); paint();
        }).catch(function(e){
          var msg=(e&&(e.message||e.type))||'';
          err.textContent=/already|set/i.test(msg)?'Your birthday is already saved with us. Refresh the page to see it.':'That didn’t save. Please try again.';
          err.hidden=false;
        }).then(function(){ saveBtn.disabled=false; saveBtn.textContent='Yes, save my birthday'; });
      });
      sheet.addEventListener('click',function(ev){ if(ev.target.closest('[data-bday-close]')) close(); });
    }
    document.addEventListener('click',function(ev){ var o=ev.target.closest('[data-bday-open]'); if(o){ ev.preventDefault(); ev.stopPropagation(); open(); } },true);
    document.addEventListener('keydown',function(ev){
      if(ev.key==='Escape' && sheet && sheet.classList.contains('is-open')) close();
      if((ev.key==='Enter'||ev.key===' ') && ev.target.closest && ev.target.closest('.tile[data-bday-open]')){ ev.preventDefault(); open(); }
    });
    // Repaint the moment LoyaltyLion's store changes the birthday (save here, or anywhere else).
    var hooked=false;
    function hook(){ var st=store(); if(hooked||!st) return; hooked=true; lastBd=bday();
      st.subscribe(function(){ var b=bday(); if(b!==lastBd){ lastBd=b; paint(); } }); }
    var tries=0, iv=setInterval(function(){ hook(); if(hooked||++tries>60) clearInterval(iv); },500);
    return {paint:paint, setTier:function(i){ tier=Math.max(0,Math.min(2,i|0)); }, open:open};
  })();

  // wait for LoyaltyLion SDK + customer (loads via GTM, async); default to guest
  // ---- Wait for LoyaltyLion, then render ------------------------------------
  // The SDK boots in stages (loader.js -> start/<token>.js -> authenticate customer),
  // so window.loyaltylion.customer can appear well after DOM ready. Polling alone was
  // giving up too early and leaving a logged-in member staring at a hollow shell
  // (name from Shopify, but 0 Crumbs / blank tier goal). So: hook the SDK's own
  // 'ready' event (the loader buffers `on` calls made before the SDK lands) AND keep
  // a longer poll as a belt-and-braces fallback.
  // Preview mode short-circuits the whole LoyaltyLion wait — see hubDemo().
  if(/[?&]rc_demo=1/.test(location.search)){
    try{ hubDemo(); }catch(e){ if(window.console) console.error('[sweet-club] demo failed:',e); }
    return;
  }

  var done=false, start=Date.now();
  function tryRender(){
    if(done) return true;
    var ll=window.loyaltylion;
    if(ll && ll.customer && ll.customer.enrolled){ done=true; render(ll.customer); subscribeLiveUpdates(); return true; }
    return false;
  }
  // LIVE UPDATES. The SDK has no public "customer changed" event, but its UI runs on a redux-style
  // store (loyaltylion.ui.store) whose `customer` node is what LoyaltyLion's own widgets re-render
  // from. We subscribe to it: when a claim/redemption lands (points, completedRules or claimedRewards
  // change), re-render our tiles/balance/quest from the fresh customer — so "Claim →" flips to
  // "✓ Claimed" and the balance ticks up with no page refresh. Signature-gated so we only re-render
  // on a real change, and render() is already safe to re-run (the goal picker re-renders the same way).
  var __liveSubbed=false;
  function subscribeLiveUpdates(){
    if(__liveSubbed) return;
    try{
      var store=window.loyaltylion && window.loyaltylion.ui && window.loyaltylion.ui.store;
      if(!store || typeof store.subscribe!=='function' || typeof store.getState!=='function'){
        if(Date.now()-start<30000) setTimeout(subscribeLiveUpdates,600);   // store mounts slightly after auth
        return;
      }
      __liveSubbed=true;
      var sig=function(cu){ return cu ? (cu.pointsApproved+'|'+(cu.completedRules||[]).length+'|'+(cu.claimedRewards||[]).length+'|'+(cu.pointsRedeemable||0)) : ''; };
      var last=sig((store.getState()||{}).customer);
      store.subscribe(function(){
        var cu=(store.getState()||{}).customer;
        if(!cu || !cu.enrolled) return;
        var s=sig(cu);
        if(s===last) return;
        last=s;
        try{ render(cu); }catch(e){ if(window.console) console.warn('[sweet-club] live re-render failed:',e); }
      });
    }catch(e){}
  }
  try{
    if(window.loyaltylion && typeof window.loyaltylion.on==='function'){
      window.loyaltylion.on('ready', function(){ if(!tryRender()) giveUp(); });
    }
  }catch(e){}
  function giveUp(){
    if(done) return; done=true;
    if(club.dataset.shopifyCustomer!=='1'){ toGuest(); return; }
    // Logged into Shopify but LoyaltyLion never answered. Don't fake a 0 balance and
    // don't show "join now" to an existing member — say plainly that it didn't load.
    var b=q('[data-ll="points"]'); if(b) b.textContent='—';
    // The failure message used to live in the hero's tier-tracker line. That line is gone, so
    // it now lands in the next-tier panel — the one surface beside the card that is always
    // rendered. Losing this would leave a member staring at a dash with no explanation, which
    // is the single worst state this page can be in.
    var g=q('[data-hub="nextText"]')||q('[data-ll="goal"]');
    if(g) g.innerHTML='We couldn’t load your Crumbs just now — please refresh the page.';
    var gl=q('[data-hub="nextLabel"]'); if(gl) gl.textContent='Not loaded';
  }
  (function poll(){
    if(tryRender()) return;
    if(Date.now()-start>25000){ giveUp(); return; }
    setTimeout(poll,400);
  })();
})();